var _g, _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _path5, _path6, _path7, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _path8, _path9, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _rect441, _rect442, _path131, _rect443, _rect444, _rect445, _rect446, _path132, _path133, _path134, _ellipse, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _circle, _path246, _path247, _path248, _path249, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 357,
    viewBox: "0 0 354 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_2931_42414)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.33276,
    y: 88.7556,
    width: 112.337,
    height: 134.012,
    fill: "#527DA9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.786,
    y: 153,
    width: 108,
    height: 132,
    fill: "#527DA9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.786,
    y: 52,
    width: 125,
    height: 86,
    fill: "#527DA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.167 199.014C351.167 233.892 327.361 262.014 298.167 262.014C268.973 262.014 245.167 233.892 245.167 199.014C245.167 164.137 268.973 136.014 298.167 136.014C327.361 136.014 351.167 164.137 351.167 199.014Z",
    fill: "#527DA9",
    stroke: "#6F9AC7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7865,
    y: 91,
    width: 92,
    height: 117,
    fill: "#7CA8D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.7865,
    y: 82,
    width: 108,
    height: 135,
    fill: "#6F9AC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7865 97C16.7865 93.4 14.4532 91.8333 13.2865 91.5V207.5C14.4532 207 16.7865 205.5 16.7865 203.5V97Z",
    fill: "#7CA8D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7865 92C18.7865 94 20.1198 96.1667 20.7865 97H101.786V95C85.7865 93 21.7865 92 18.7865 92Z",
    fill: "#7CA8D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7865 202C21.7865 202 18.4532 205.667 17.2865 207.5H103.786C98.2865 203 30.7865 202 25.7865 202Z",
    fill: "#7CA8D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7865 82L101.786 84H6.7865V217H4.7865V82Z",
    fill: "#B5D4F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7865,
    y: 99,
    width: 80,
    height: 101,
    fill: "#7CA8D6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.2865,
    y: 85.5,
    width: 101,
    height: 128,
    stroke: "#527DA9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2865,
    y: 91.5,
    width: 91,
    height: 116,
    stroke: "#B5D4F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7894 97H81.7894C81.7894 97 61.2865 93 19.7894 93V94.5L20.7894 97Z",
    fill: "#B5D4F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 97C100.786 94.6 103.12 92.3333 104.286 91.5V207.5C103.12 206.833 100.786 205.1 100.786 203.5V97Z",
    fill: "#B5D4F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7865 204.5C19.9865 204.5 17.6198 206.5 17.2865 207.5H99.7865C95.2865 204.5 35.2865 204.5 26.7865 204.5Z",
    fill: "#B5D4F5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7865,
    y: 102,
    width: 74,
    height: 95,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 49.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 59.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 59.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 61.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 73.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 91.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 52.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 62.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 62.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 40.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 76.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 92.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 92.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 94.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 53.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 53.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 85.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 41.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 41.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 77.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 77.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 79.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 56.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 56.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 68.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 68.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 88.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 82.7865,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 98.7865,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 98.7865,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 100.786,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 101.786,
    y: 86,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 101.786,
    y: 87,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 103.786,
    y: 86,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 47.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 49.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 59.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 59.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 61.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 73.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 91.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 16.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 52.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 62.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 62.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 38.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 40.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 74.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 76.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 92.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 92.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 94.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 53.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 53.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 65.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 85.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 41.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 41.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 77.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 77.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 79.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 95.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 56.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 56.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 32.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 68.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 68.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 70.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 88.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 82.7865,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 98.7865,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 98.7865,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 100.786,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 101.786,
    y: 210,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 101.786,
    y: 211,
    width: 2,
    height: 2,
    fill: "#7CA8D6"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 103.786,
    y: 210,
    width: 1,
    height: 3,
    fill: "#527DA9"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 106.786,
    y: 89,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 90,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 91,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 91)",
    fill: "#527DA9"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 92,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 93,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 94,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 94)",
    fill: "#527DA9"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 116,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 117,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 118,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 118)",
    fill: "#527DA9"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 140,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 141,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 142,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 142)",
    fill: "#527DA9"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 164,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 165,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 166,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 166)",
    fill: "#527DA9"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 188,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 189,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 190,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 190)",
    fill: "#527DA9"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 104,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 105,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 106,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 106)",
    fill: "#527DA9"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 128,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 129,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 130,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 130)",
    fill: "#527DA9"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 152,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 153,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 154,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 154)",
    fill: "#527DA9"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 176,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 177,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 178,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 178)",
    fill: "#527DA9"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 200,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 201,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 202,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 202)",
    fill: "#527DA9"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 98,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 99,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 100,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 100)",
    fill: "#527DA9"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 122,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 123,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 124,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 124)",
    fill: "#527DA9"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 146,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 147,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 148,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 148)",
    fill: "#527DA9"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 170,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 171,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 172,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 172)",
    fill: "#527DA9"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 194,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 195,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 196,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 196)",
    fill: "#527DA9"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 110,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 111,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 112,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 112)",
    fill: "#527DA9"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 134,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 135,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 136,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 136)",
    fill: "#527DA9"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 158,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 159,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 160,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 160)",
    fill: "#527DA9"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 182,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 183,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 184,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 184)",
    fill: "#527DA9"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 206,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 207,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 208,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 208)",
    fill: "#527DA9"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 95,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 96,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 97,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 97)",
    fill: "#527DA9"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 119,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 120,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 121,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 121)",
    fill: "#527DA9"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 143,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 144,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 145,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 145)",
    fill: "#527DA9"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 167,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 168,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 169,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 169)",
    fill: "#527DA9"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 191,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 192,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 193,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 193)",
    fill: "#527DA9"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 107,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 108,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 109,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 109)",
    fill: "#527DA9"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 131,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 132,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 133,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 133)",
    fill: "#527DA9"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 155,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 156,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 157,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 157)",
    fill: "#527DA9"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 179,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 180,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 181,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 181)",
    fill: "#527DA9"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 203,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 204,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 205,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 205)",
    fill: "#527DA9"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 101,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 102,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 103,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 103)",
    fill: "#527DA9"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 125,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 126,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 127,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 127)",
    fill: "#527DA9"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 149,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 150,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 151,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 151)",
    fill: "#527DA9"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 173,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 174,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 175,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 175)",
    fill: "#527DA9"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 197,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 198,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 199,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 199)",
    fill: "#527DA9"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 113,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 114,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 115,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 115)",
    fill: "#527DA9"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 137,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 138,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 139,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 139)",
    fill: "#527DA9"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 161,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 162,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 163,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 163)",
    fill: "#527DA9"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 185,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 105.786,
    y: 186,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 108.786,
    y: 187,
    width: 1,
    height: 2,
    transform: "rotate(90 108.786 187)",
    fill: "#527DA9"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 9.7865,
    y: 89,
    width: 2,
    height: 1,
    fill: "#F0F7FE"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 90,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 91,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 91)",
    fill: "#527DA9"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 92,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 93,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 94,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 94)",
    fill: "#527DA9"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 116,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 117,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 118,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 118)",
    fill: "#527DA9"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 140,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 141,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 142,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 142)",
    fill: "#527DA9"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 164,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 165,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 166,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 166)",
    fill: "#527DA9"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 188,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 189,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 190,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 190)",
    fill: "#527DA9"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 104,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 105,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 106,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 106)",
    fill: "#527DA9"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 128,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 129,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 130,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 130)",
    fill: "#527DA9"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 152,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 153,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 154,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 154)",
    fill: "#527DA9"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 176,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 177,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 178,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 178)",
    fill: "#527DA9"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 200,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 201,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 202,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 202)",
    fill: "#527DA9"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 98,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 99,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 100,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 100)",
    fill: "#527DA9"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 122,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 123,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 124,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 124)",
    fill: "#527DA9"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 146,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 147,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 148,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 148)",
    fill: "#527DA9"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 170,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 171,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 172,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 172)",
    fill: "#527DA9"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 194,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 195,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 196,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 196)",
    fill: "#527DA9"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 110,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 111,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 112,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 112)",
    fill: "#527DA9"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 134,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 135,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 136,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 136)",
    fill: "#527DA9"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 158,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 159,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 160,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 160)",
    fill: "#527DA9"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 182,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 183,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 184,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 184)",
    fill: "#527DA9"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 206,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 207,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 208,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 208)",
    fill: "#527DA9"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 95,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 96,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 97,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 97)",
    fill: "#527DA9"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 119,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 120,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 121,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 121)",
    fill: "#527DA9"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 143,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 144,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 145,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 145)",
    fill: "#527DA9"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 167,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 168,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 169,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 169)",
    fill: "#527DA9"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 191,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 192,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 193,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 193)",
    fill: "#527DA9"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 107,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 108,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 109,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 109)",
    fill: "#527DA9"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 131,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 132,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 133,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 133)",
    fill: "#527DA9"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 155,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 156,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 157,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 157)",
    fill: "#527DA9"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 179,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 180,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 181,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 181)",
    fill: "#527DA9"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 203,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 204,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 205,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 205)",
    fill: "#527DA9"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 101,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 102,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 103,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 103)",
    fill: "#527DA9"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 125,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 126,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 127,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 127)",
    fill: "#527DA9"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 149,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 150,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 151,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 151)",
    fill: "#527DA9"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 173,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 174,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 175,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 175)",
    fill: "#527DA9"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 197,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 198,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 199,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 199)",
    fill: "#527DA9"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 113,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 114,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 115,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 115)",
    fill: "#527DA9"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 137,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 138,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 139,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 139)",
    fill: "#527DA9"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 161,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 162,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 163,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 163)",
    fill: "#527DA9"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 185,
    width: 3,
    height: 1,
    fill: "#F0F7FE"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7865,
    y: 186,
    width: 3,
    height: 2,
    fill: "#7CA8D6"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7865,
    y: 187,
    width: 1,
    height: 2,
    transform: "rotate(90 11.7865 187)",
    fill: "#527DA9"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 127.286,
    y: 49.5,
    width: 120,
    height: 84,
    fill: "#7CA8D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.286 49L126.786 49V134.5",
    stroke: "#B5D4F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.286 134H247.786V49.5",
    stroke: "#527DA9"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 129.786,
    y: 52,
    width: 115,
    height: 79,
    fill: "#7CA8D6",
    stroke: "#527DA9"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 135.786,
    y: 58,
    width: 103,
    height: 67,
    stroke: "#527DA9"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 139.286,
    y: 61.5,
    width: 96,
    height: 60,
    fill: "#6F9AC7"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 139.786,
    y: 62,
    width: 95,
    height: 59,
    stroke: "#527DA9"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 148.786,
    y: 71,
    width: 77,
    height: 41,
    stroke: "#7CA8D6"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 149.286,
    y: 71.5,
    width: 76,
    height: 40,
    fill: "white"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 138.786,
    y: 61,
    width: 97,
    height: 61,
    stroke: "#6F9AC7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M233.286 116C227.686 110.8 226.953 83.5 227.286 70.5L233.286 65V116Z",
    fill: "#7CA8D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.286 63.5H233.286L146.786 69.5L141.286 63.5Z",
    fill: "#7CA8D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.286 70.5L141.286 65V95C146.086 91.8 146.62 77.3333 146.286 70.5Z",
    fill: "#7CA8D6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M164.286 63.5C157.786 63.5 151.286 65 146.786 68.5V69.5H226.786L233.286 63.5H164.286Z",
    fill: "#B5D4F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M233.286 65L227.286 70.5C227.286 77.3 231.286 80.3333 233.286 81V65Z",
    fill: "#B5D4F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.286 52.5C155.086 52.5 152.453 55.5 151.786 57C153.453 57.1667 157.486 57.5 160.286 57.5C165.786 57.5 166.786 54.1667 167.286 52.5H160.286Z",
    fill: "#B5D4F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160.286 52.5C155.086 52.5 152.453 55.5 151.786 57C153.453 57.1667 157.486 57.5 160.286 57.5C165.786 57.5 166.786 54.1667 167.286 52.5H160.286Z",
    fill: "#B5D4F5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M160.286 52.5C155.086 52.5 152.453 55.5 151.786 57C153.453 57.1667 157.486 57.5 160.286 57.5C165.786 57.5 166.786 54.1667 167.286 52.5H160.286Z",
    fill: "#B5D4F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.286 52.5C155.086 52.5 152.453 55.5 151.786 57C153.453 57.1667 157.486 57.5 160.286 57.5C165.786 57.5 166.786 54.1667 167.286 52.5H160.286Z",
    stroke: "#6F9AC7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166.786 52.5H160.287C157.248 52.5 155.692 53.8492 154.286 55C158.155 55.6083 165.186 55.7 166.786 52.5Z",
    fill: "#F0F7FE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M234.286 52.5C229.086 52.5 226.453 55.5 225.786 57C227.453 57.1667 231.486 57.5 234.286 57.5C239.786 57.5 240.786 54.1667 241.286 52.5H234.286Z",
    fill: "#B5D4F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M234.286 52.5C229.086 52.5 226.453 55.5 225.786 57C227.453 57.1667 231.486 57.5 234.286 57.5C239.786 57.5 240.786 54.1667 241.286 52.5H234.286Z",
    fill: "#B5D4F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M234.286 52.5C229.086 52.5 226.453 55.5 225.786 57C227.453 57.1667 231.486 57.5 234.286 57.5C239.786 57.5 240.786 54.1667 241.286 52.5H234.286Z",
    fill: "#B5D4F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M234.286 52.5C229.086 52.5 226.453 55.5 225.786 57C227.453 57.1667 231.486 57.5 234.286 57.5C239.786 57.5 240.786 54.1667 241.286 52.5H234.286Z",
    stroke: "#6F9AC7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M240.786 52.5H234.287C231.248 52.5 229.692 53.8492 228.286 55C232.155 55.6083 239.186 55.7 240.786 52.5Z",
    fill: "#F0F7FE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 52.5C192.086 52.5 189.453 55.5 188.786 57C190.453 57.1667 194.486 57.5 197.286 57.5C202.786 57.5 203.786 54.1667 204.286 52.5H197.286Z",
    fill: "#B5D4F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 52.5C192.086 52.5 189.453 55.5 188.786 57C190.453 57.1667 194.486 57.5 197.286 57.5C202.786 57.5 203.786 54.1667 204.286 52.5H197.286Z",
    fill: "#B5D4F5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 52.5C192.086 52.5 189.453 55.5 188.786 57C190.453 57.1667 194.486 57.5 197.286 57.5C202.786 57.5 203.786 54.1667 204.286 52.5H197.286Z",
    fill: "#B5D4F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 52.5C192.086 52.5 189.453 55.5 188.786 57C190.453 57.1667 194.486 57.5 197.286 57.5C202.786 57.5 203.786 54.1667 204.286 52.5H197.286Z",
    stroke: "#6F9AC7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.786 52.5H197.287C194.248 52.5 192.692 53.8492 191.286 55C195.155 55.6083 202.186 55.7 203.786 52.5Z",
    fill: "#F0F7FE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M141.786 52.5C136.586 52.5 133.953 55.5 133.286 57C134.953 57.1667 138.986 57.5 141.786 57.5C147.286 57.5 148.286 54.1667 148.786 52.5H141.786Z",
    fill: "#B5D4F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M141.786 52.5C136.586 52.5 133.953 55.5 133.286 57C134.953 57.1667 138.986 57.5 141.786 57.5C147.286 57.5 148.286 54.1667 148.786 52.5H141.786Z",
    fill: "#B5D4F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.786 52.5C136.586 52.5 133.953 55.5 133.286 57C134.953 57.1667 138.986 57.5 141.786 57.5C147.286 57.5 148.286 54.1667 148.786 52.5H141.786Z",
    fill: "#B5D4F5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M141.786 52.5C136.586 52.5 133.953 55.5 133.286 57C134.953 57.1667 138.986 57.5 141.786 57.5C147.286 57.5 148.286 54.1667 148.786 52.5H141.786Z",
    stroke: "#6F9AC7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M148.286 52.5H141.787C138.748 52.5 137.192 53.8492 135.786 55C139.655 55.6083 146.686 55.7 148.286 52.5Z",
    fill: "#F0F7FE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M215.786 52.5C210.586 52.5 207.953 55.5 207.286 57C208.953 57.1667 212.986 57.5 215.786 57.5C221.286 57.5 222.286 54.1667 222.786 52.5H215.786Z",
    fill: "#B5D4F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M215.786 52.5C210.586 52.5 207.953 55.5 207.286 57C208.953 57.1667 212.986 57.5 215.786 57.5C221.286 57.5 222.286 54.1667 222.786 52.5H215.786Z",
    fill: "#B5D4F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M215.786 52.5C210.586 52.5 207.953 55.5 207.286 57C208.953 57.1667 212.986 57.5 215.786 57.5C221.286 57.5 222.286 54.1667 222.786 52.5H215.786Z",
    fill: "#B5D4F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M215.786 52.5C210.586 52.5 207.953 55.5 207.286 57C208.953 57.1667 212.986 57.5 215.786 57.5C221.286 57.5 222.286 54.1667 222.786 52.5H215.786Z",
    stroke: "#6F9AC7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M222.286 52.5H215.787C212.748 52.5 211.192 53.8492 209.786 55C213.655 55.6083 220.686 55.7 222.286 52.5Z",
    fill: "#F0F7FE"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M178.786 52.5C173.586 52.5 170.953 55.5 170.286 57C171.953 57.1667 175.986 57.5 178.786 57.5C184.286 57.5 185.286 54.1667 185.786 52.5H178.786Z",
    fill: "#B5D4F5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M178.786 52.5C173.586 52.5 170.953 55.5 170.286 57C171.953 57.1667 175.986 57.5 178.786 57.5C184.286 57.5 185.286 54.1667 185.786 52.5H178.786Z",
    fill: "#B5D4F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M178.786 52.5C173.586 52.5 170.953 55.5 170.286 57C171.953 57.1667 175.986 57.5 178.786 57.5C184.286 57.5 185.286 54.1667 185.786 52.5H178.786Z",
    fill: "#B5D4F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M178.786 52.5C173.586 52.5 170.953 55.5 170.286 57C171.953 57.1667 175.986 57.5 178.786 57.5C184.286 57.5 185.286 54.1667 185.786 52.5H178.786Z",
    stroke: "#6F9AC7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M185.286 52.5H178.787C175.748 52.5 174.192 53.8492 172.786 55C176.655 55.6083 183.686 55.7 185.286 52.5Z",
    fill: "#F0F7FE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 62.6399C130.286 67.8399 133.286 70.4733 134.786 71.1399C134.953 69.4733 135.286 65.4399 135.286 62.6399C135.286 57.1399 131.953 56.1399 130.286 55.6399L130.286 62.6399Z",
    fill: "#B5D4F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 62.6399C130.286 67.8399 133.286 70.4733 134.786 71.1399C134.953 69.4733 135.286 65.4399 135.286 62.6399C135.286 57.1399 131.953 56.1399 130.286 55.6399L130.286 62.6399Z",
    fill: "#B5D4F5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 62.6399C130.286 67.8399 133.286 70.4733 134.786 71.1399C134.953 69.4733 135.286 65.4399 135.286 62.6399C135.286 57.1399 131.953 56.1399 130.286 55.6399L130.286 62.6399Z",
    fill: "#B5D4F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 62.6399C130.286 67.8399 133.286 70.4733 134.786 71.1399C134.953 69.4733 135.286 65.4399 135.286 62.6399C135.286 57.1399 131.953 56.1399 130.286 55.6399L130.286 62.6399Z",
    stroke: "#6F9AC7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 56.1399L130.286 58.6399C130.286 61.6784 132.551 62.1399 132.786 60.6399C133.395 56.7712 133.486 57.7399 130.286 56.1399Z",
    fill: "#F0F7FE"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 62.6399C239.286 67.8399 242.286 70.4733 243.786 71.1399C243.953 69.4733 244.286 65.4399 244.286 62.6399C244.286 57.1399 240.953 56.1399 239.286 55.6399L239.286 62.6399Z",
    fill: "#B5D4F5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 62.6399C239.286 67.8399 242.286 70.4733 243.786 71.1399C243.953 69.4733 244.286 65.4399 244.286 62.6399C244.286 57.1399 240.953 56.1399 239.286 55.6399L239.286 62.6399Z",
    fill: "#B5D4F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 62.6399C239.286 67.8399 242.286 70.4733 243.786 71.1399C243.953 69.4733 244.286 65.4399 244.286 62.6399C244.286 57.1399 240.953 56.1399 239.286 55.6399L239.286 62.6399Z",
    fill: "#B5D4F5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 62.6399C239.286 67.8399 242.286 70.4733 243.786 71.1399C243.953 69.4733 244.286 65.4399 244.286 62.6399C244.286 57.1399 240.953 56.1399 239.286 55.6399L239.286 62.6399Z",
    stroke: "#6F9AC7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 56.1399L239.286 58.6399C239.286 61.6784 241.551 62.1399 241.786 60.6399C242.395 56.7712 242.486 57.7399 239.286 56.1399Z",
    fill: "#F0F7FE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 100.14C130.286 105.34 133.286 107.973 134.786 108.64C134.953 106.973 135.286 102.94 135.286 100.14C135.286 94.6399 131.953 93.6399 130.286 93.1399L130.286 100.14Z",
    fill: "#B5D4F5"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 100.14C130.286 105.34 133.286 107.973 134.786 108.64C134.953 106.973 135.286 102.94 135.286 100.14C135.286 94.6399 131.953 93.6399 130.286 93.1399L130.286 100.14Z",
    fill: "#B5D4F5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 100.14C130.286 105.34 133.286 107.973 134.786 108.64C134.953 106.973 135.286 102.94 135.286 100.14C135.286 94.6399 131.953 93.6399 130.286 93.1399L130.286 100.14Z",
    fill: "#B5D4F5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 100.14C130.286 105.34 133.286 107.973 134.786 108.64C134.953 106.973 135.286 102.94 135.286 100.14C135.286 94.6399 131.953 93.6399 130.286 93.1399L130.286 100.14Z",
    stroke: "#6F9AC7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 93.6399L130.286 96.1399C130.286 99.1784 132.551 99.6399 132.786 98.1399C133.395 94.2712 133.486 95.2399 130.286 93.6399Z",
    fill: "#F0F7FE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 100.14C239.286 105.34 242.286 107.973 243.786 108.64C243.953 106.973 244.286 102.94 244.286 100.14C244.286 94.6399 240.953 93.6399 239.286 93.1399L239.286 100.14Z",
    fill: "#B5D4F5"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 100.14C239.286 105.34 242.286 107.973 243.786 108.64C243.953 106.973 244.286 102.94 244.286 100.14C244.286 94.6399 240.953 93.6399 239.286 93.1399L239.286 100.14Z",
    fill: "#B5D4F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 100.14C239.286 105.34 242.286 107.973 243.786 108.64C243.953 106.973 244.286 102.94 244.286 100.14C244.286 94.6399 240.953 93.6399 239.286 93.1399L239.286 100.14Z",
    fill: "#B5D4F5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 100.14C239.286 105.34 242.286 107.973 243.786 108.64C243.953 106.973 244.286 102.94 244.286 100.14C244.286 94.6399 240.953 93.6399 239.286 93.1399L239.286 100.14Z",
    stroke: "#6F9AC7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 93.6399L239.286 96.1399C239.286 99.1784 241.551 99.6399 241.786 98.1399C242.395 94.2712 242.486 95.2399 239.286 93.6399Z",
    fill: "#F0F7FE"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 81.1399C130.286 86.3399 133.286 88.9733 134.786 89.6399C134.953 87.9733 135.286 83.9399 135.286 81.1399C135.286 75.6399 131.953 74.6399 130.286 74.1399L130.286 81.1399Z",
    fill: "#B5D4F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 81.1399C130.286 86.3399 133.286 88.9733 134.786 89.6399C134.953 87.9733 135.286 83.9399 135.286 81.1399C135.286 75.6399 131.953 74.6399 130.286 74.1399L130.286 81.1399Z",
    fill: "#B5D4F5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 81.1399C130.286 86.3399 133.286 88.9733 134.786 89.6399C134.953 87.9733 135.286 83.9399 135.286 81.1399C135.286 75.6399 131.953 74.6399 130.286 74.1399L130.286 81.1399Z",
    fill: "#B5D4F5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 81.1399C130.286 86.3399 133.286 88.9733 134.786 89.6399C134.953 87.9733 135.286 83.9399 135.286 81.1399C135.286 75.6399 131.953 74.6399 130.286 74.1399L130.286 81.1399Z",
    stroke: "#6F9AC7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 74.6399L130.286 77.1399C130.286 80.1784 132.551 80.6399 132.786 79.1399C133.395 75.2712 133.486 76.2399 130.286 74.6399Z",
    fill: "#F0F7FE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 81.1399C239.286 86.3399 242.286 88.9733 243.786 89.6399C243.953 87.9733 244.286 83.9399 244.286 81.1399C244.286 75.6399 240.953 74.6399 239.286 74.1399L239.286 81.1399Z",
    fill: "#B5D4F5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 81.1399C239.286 86.3399 242.286 88.9733 243.786 89.6399C243.953 87.9733 244.286 83.9399 244.286 81.1399C244.286 75.6399 240.953 74.6399 239.286 74.1399L239.286 81.1399Z",
    fill: "#B5D4F5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 81.1399C239.286 86.3399 242.286 88.9733 243.786 89.6399C243.953 87.9733 244.286 83.9399 244.286 81.1399C244.286 75.6399 240.953 74.6399 239.286 74.1399L239.286 81.1399Z",
    fill: "#B5D4F5"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 81.1399C239.286 86.3399 242.286 88.9733 243.786 89.6399C243.953 87.9733 244.286 83.9399 244.286 81.1399C244.286 75.6399 240.953 74.6399 239.286 74.1399L239.286 81.1399Z",
    stroke: "#6F9AC7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 74.6399L239.286 77.1399C239.286 80.1784 241.551 80.6399 241.786 79.1399C242.395 75.2712 242.486 76.2399 239.286 74.6399Z",
    fill: "#F0F7FE"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 119.14C130.286 124.34 133.286 126.973 134.786 127.64C134.953 125.973 135.286 121.94 135.286 119.14C135.286 113.64 131.953 112.64 130.286 112.14L130.286 119.14Z",
    fill: "#B5D4F5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 119.14C130.286 124.34 133.286 126.973 134.786 127.64C134.953 125.973 135.286 121.94 135.286 119.14C135.286 113.64 131.953 112.64 130.286 112.14L130.286 119.14Z",
    fill: "#B5D4F5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 119.14C130.286 124.34 133.286 126.973 134.786 127.64C134.953 125.973 135.286 121.94 135.286 119.14C135.286 113.64 131.953 112.64 130.286 112.14L130.286 119.14Z",
    fill: "#B5D4F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 119.14C130.286 124.34 133.286 126.973 134.786 127.64C134.953 125.973 135.286 121.94 135.286 119.14C135.286 113.64 131.953 112.64 130.286 112.14L130.286 119.14Z",
    stroke: "#6F9AC7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M130.286 112.64L130.286 115.14C130.286 118.178 132.551 118.64 132.786 117.14C133.395 113.271 133.486 114.24 130.286 112.64Z",
    fill: "#F0F7FE"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 119.14C239.286 124.34 242.286 126.973 243.786 127.64C243.953 125.973 244.286 121.94 244.286 119.14C244.286 113.64 240.953 112.64 239.286 112.14L239.286 119.14Z",
    fill: "#B5D4F5"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 119.14C239.286 124.34 242.286 126.973 243.786 127.64C243.953 125.973 244.286 121.94 244.286 119.14C244.286 113.64 240.953 112.64 239.286 112.14L239.286 119.14Z",
    fill: "#B5D4F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 119.14C239.286 124.34 242.286 126.973 243.786 127.64C243.953 125.973 244.286 121.94 244.286 119.14C244.286 113.64 240.953 112.64 239.286 112.14L239.286 119.14Z",
    fill: "#B5D4F5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 119.14C239.286 124.34 242.286 126.973 243.786 127.64C243.953 125.973 244.286 121.94 244.286 119.14C244.286 113.64 240.953 112.64 239.286 112.14L239.286 119.14Z",
    stroke: "#6F9AC7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M239.286 112.64L239.286 115.14C239.286 118.178 241.551 118.64 241.786 117.14C242.395 113.271 242.486 114.24 239.286 112.64Z",
    fill: "#F0F7FE"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M160.286 125.5C155.086 125.5 152.453 128.5 151.786 130C153.453 130.167 157.486 130.5 160.286 130.5C165.786 130.5 166.786 127.167 167.286 125.5H160.286Z",
    fill: "#B5D4F5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M160.286 125.5C155.086 125.5 152.453 128.5 151.786 130C153.453 130.167 157.486 130.5 160.286 130.5C165.786 130.5 166.786 127.167 167.286 125.5H160.286Z",
    fill: "#B5D4F5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M160.286 125.5C155.086 125.5 152.453 128.5 151.786 130C153.453 130.167 157.486 130.5 160.286 130.5C165.786 130.5 166.786 127.167 167.286 125.5H160.286Z",
    fill: "#B5D4F5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M160.286 125.5C155.086 125.5 152.453 128.5 151.786 130C153.453 130.167 157.486 130.5 160.286 130.5C165.786 130.5 166.786 127.167 167.286 125.5H160.286Z",
    stroke: "#6F9AC7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M166.786 125.5H160.287C157.248 125.5 155.692 126.849 154.286 128C158.155 128.608 165.186 128.7 166.786 125.5Z",
    fill: "#F0F7FE"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M234.286 125.5C229.086 125.5 226.453 128.5 225.786 130C227.453 130.167 231.486 130.5 234.286 130.5C239.786 130.5 240.786 127.167 241.286 125.5H234.286Z",
    fill: "#B5D4F5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M234.286 125.5C229.086 125.5 226.453 128.5 225.786 130C227.453 130.167 231.486 130.5 234.286 130.5C239.786 130.5 240.786 127.167 241.286 125.5H234.286Z",
    fill: "#B5D4F5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M234.286 125.5C229.086 125.5 226.453 128.5 225.786 130C227.453 130.167 231.486 130.5 234.286 130.5C239.786 130.5 240.786 127.167 241.286 125.5H234.286Z",
    fill: "#B5D4F5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M234.286 125.5C229.086 125.5 226.453 128.5 225.786 130C227.453 130.167 231.486 130.5 234.286 130.5C239.786 130.5 240.786 127.167 241.286 125.5H234.286Z",
    stroke: "#6F9AC7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M240.786 125.5H234.287C231.248 125.5 229.692 126.849 228.286 128C232.155 128.608 239.186 128.7 240.786 125.5Z",
    fill: "#F0F7FE"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 125.5C192.086 125.5 189.453 128.5 188.786 130C190.453 130.167 194.486 130.5 197.286 130.5C202.786 130.5 203.786 127.167 204.286 125.5H197.286Z",
    fill: "#B5D4F5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 125.5C192.086 125.5 189.453 128.5 188.786 130C190.453 130.167 194.486 130.5 197.286 130.5C202.786 130.5 203.786 127.167 204.286 125.5H197.286Z",
    fill: "#B5D4F5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 125.5C192.086 125.5 189.453 128.5 188.786 130C190.453 130.167 194.486 130.5 197.286 130.5C202.786 130.5 203.786 127.167 204.286 125.5H197.286Z",
    fill: "#B5D4F5"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M197.286 125.5C192.086 125.5 189.453 128.5 188.786 130C190.453 130.167 194.486 130.5 197.286 130.5C202.786 130.5 203.786 127.167 204.286 125.5H197.286Z",
    stroke: "#6F9AC7"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M203.786 125.5H197.287C194.248 125.5 192.692 126.849 191.286 128C195.155 128.608 202.186 128.7 203.786 125.5Z",
    fill: "#F0F7FE"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M141.786 125.5C136.586 125.5 133.953 128.5 133.286 130C134.953 130.167 138.986 130.5 141.786 130.5C147.286 130.5 148.286 127.167 148.786 125.5H141.786Z",
    fill: "#B5D4F5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M141.786 125.5C136.586 125.5 133.953 128.5 133.286 130C134.953 130.167 138.986 130.5 141.786 130.5C147.286 130.5 148.286 127.167 148.786 125.5H141.786Z",
    fill: "#B5D4F5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M141.786 125.5C136.586 125.5 133.953 128.5 133.286 130C134.953 130.167 138.986 130.5 141.786 130.5C147.286 130.5 148.286 127.167 148.786 125.5H141.786Z",
    fill: "#B5D4F5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M141.786 125.5C136.586 125.5 133.953 128.5 133.286 130C134.953 130.167 138.986 130.5 141.786 130.5C147.286 130.5 148.286 127.167 148.786 125.5H141.786Z",
    stroke: "#6F9AC7"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M148.286 125.5H141.787C138.748 125.5 137.192 126.849 135.786 128C139.655 128.608 146.686 128.7 148.286 125.5Z",
    fill: "#F0F7FE"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M215.786 125.5C210.586 125.5 207.953 128.5 207.286 130C208.953 130.167 212.986 130.5 215.786 130.5C221.286 130.5 222.286 127.167 222.786 125.5H215.786Z",
    fill: "#B5D4F5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M215.786 125.5C210.586 125.5 207.953 128.5 207.286 130C208.953 130.167 212.986 130.5 215.786 130.5C221.286 130.5 222.286 127.167 222.786 125.5H215.786Z",
    fill: "#B5D4F5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M215.786 125.5C210.586 125.5 207.953 128.5 207.286 130C208.953 130.167 212.986 130.5 215.786 130.5C221.286 130.5 222.286 127.167 222.786 125.5H215.786Z",
    fill: "#B5D4F5"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M215.786 125.5C210.586 125.5 207.953 128.5 207.286 130C208.953 130.167 212.986 130.5 215.786 130.5C221.286 130.5 222.286 127.167 222.786 125.5H215.786Z",
    stroke: "#6F9AC7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M222.286 125.5H215.787C212.748 125.5 211.192 126.849 209.786 128C213.655 128.608 220.686 128.7 222.286 125.5Z",
    fill: "#F0F7FE"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M178.786 125.5C173.586 125.5 170.953 128.5 170.286 130C171.953 130.167 175.986 130.5 178.786 130.5C184.286 130.5 185.286 127.167 185.786 125.5H178.786Z",
    fill: "#B5D4F5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M178.786 125.5C173.586 125.5 170.953 128.5 170.286 130C171.953 130.167 175.986 130.5 178.786 130.5C184.286 130.5 185.286 127.167 185.786 125.5H178.786Z",
    fill: "#B5D4F5"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M178.786 125.5C173.586 125.5 170.953 128.5 170.286 130C171.953 130.167 175.986 130.5 178.786 130.5C184.286 130.5 185.286 127.167 185.786 125.5H178.786Z",
    fill: "#B5D4F5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M178.786 125.5C173.586 125.5 170.953 128.5 170.286 130C171.953 130.167 175.986 130.5 178.786 130.5C184.286 130.5 185.286 127.167 185.786 125.5H178.786Z",
    stroke: "#6F9AC7"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M185.286 125.5H178.787C175.748 125.5 174.192 126.849 172.786 128C176.655 128.608 183.686 128.7 185.286 125.5Z",
    fill: "#F0F7FE"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M134.213 72.0195C134.42 72.8569 134.401 73.6413 134.227 74.2244C134.05 74.8201 133.747 75.1133 133.453 75.1863C133.158 75.2593 132.754 75.1415 132.318 74.6978C131.892 74.2635 131.509 73.5789 131.301 72.7414C131.093 71.904 131.112 71.1196 131.286 70.5365C131.464 69.9408 131.767 69.6476 132.061 69.5746C132.356 69.5016 132.76 69.6194 133.196 70.0631C133.622 70.4974 134.005 71.182 134.213 72.0195Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M243 72.0195C243.207 72.8569 243.188 73.6413 243.014 74.2244C242.837 74.8201 242.534 75.1133 242.239 75.1863C241.945 75.2593 241.54 75.1415 241.105 74.6978C240.679 74.2635 240.295 73.5789 240.088 72.7414C239.88 71.904 239.899 71.1196 240.073 70.5365C240.251 69.9408 240.554 69.6476 240.848 69.5746C241.143 69.5016 241.547 69.6194 241.982 70.0631C242.409 70.4974 242.792 71.182 243 72.0195Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M134.336 90.9094C134.581 91.895 134.59 92.8143 134.43 93.4951C134.264 94.2049 133.959 94.5098 133.699 94.5741C133.44 94.6384 133.028 94.5114 132.549 93.9616C132.09 93.4343 131.669 92.617 131.424 91.6314C131.18 90.6457 131.17 89.7264 131.33 89.0456C131.497 88.3358 131.802 88.0309 132.061 87.9666C132.321 87.9023 132.733 88.0293 133.212 88.5791C133.671 89.1065 134.092 89.9237 134.336 90.9094Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M243.123 90.9094C243.367 91.895 243.377 92.8143 243.217 93.4951C243.051 94.2049 242.746 94.5098 242.486 94.5741C242.227 94.6384 241.815 94.5114 241.336 93.9616C240.877 93.4343 240.456 92.617 240.211 91.6314C239.967 90.6457 239.957 89.7264 240.117 89.0456C240.284 88.3358 240.589 88.0309 240.848 87.9666C241.107 87.9023 241.52 88.0293 241.998 88.5791C242.458 89.1065 242.879 89.9237 243.123 90.9094Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M134.336 109.909C134.581 110.895 134.59 111.814 134.43 112.495C134.264 113.205 133.959 113.51 133.699 113.574C133.44 113.638 133.028 113.511 132.549 112.962C132.09 112.434 131.669 111.617 131.424 110.631C131.18 109.646 131.17 108.726 131.33 108.046C131.497 107.336 131.802 107.031 132.061 106.967C132.321 106.902 132.733 107.029 133.212 107.579C133.671 108.106 134.092 108.924 134.336 109.909Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M243.123 109.909C243.367 110.895 243.377 111.814 243.217 112.495C243.051 113.205 242.746 113.51 242.486 113.574C242.227 113.638 241.815 113.511 241.336 112.962C240.877 112.434 240.456 111.617 240.211 110.631C239.967 109.646 239.957 108.726 240.117 108.046C240.284 107.336 240.589 107.031 240.848 106.967C241.107 106.902 241.52 107.029 241.998 107.579C242.458 108.106 242.879 108.924 243.123 109.909Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M188.308 56.2132C187.47 56.4208 186.686 56.4017 186.103 56.2278C185.507 56.0501 185.214 55.7474 185.141 55.4529C185.068 55.1585 185.186 54.7539 185.63 54.3185C186.064 53.8923 186.748 53.509 187.586 53.3013C188.423 53.0937 189.208 53.1128 189.791 53.2867C190.387 53.4644 190.68 53.7671 190.753 54.0616C190.826 54.356 190.708 54.7606 190.264 55.196C189.83 55.6222 189.145 56.0055 188.308 56.2132Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M188.308 129.213C187.47 129.421 186.686 129.402 186.103 129.228C185.507 129.05 185.214 128.747 185.141 128.453C185.068 128.158 185.186 127.754 185.63 127.318C186.064 126.892 186.748 126.509 187.586 126.301C188.423 126.094 189.208 126.113 189.791 126.287C190.387 126.464 190.68 126.767 190.753 127.062C190.826 127.356 190.708 127.761 190.264 128.196C189.83 128.622 189.145 129.006 188.308 129.213Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M225.308 56.2132C224.47 56.4208 223.686 56.4017 223.103 56.2278C222.507 56.0501 222.214 55.7474 222.141 55.4529C222.068 55.1585 222.186 54.7539 222.63 54.3185C223.064 53.8923 223.748 53.509 224.586 53.3013C225.423 53.0937 226.208 53.1128 226.791 53.2867C227.387 53.4644 227.68 53.7671 227.753 54.0616C227.826 54.356 227.708 54.7606 227.264 55.196C226.83 55.6222 226.145 56.0055 225.308 56.2132Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M225.308 129.213C224.47 129.421 223.686 129.402 223.103 129.228C222.507 129.05 222.214 128.747 222.141 128.453C222.068 128.158 222.186 127.754 222.63 127.318C223.064 126.892 223.748 126.509 224.586 126.301C225.423 126.094 226.208 126.113 226.791 126.287C227.387 126.464 227.68 126.767 227.753 127.062C227.826 127.356 227.708 127.761 227.264 128.196C226.83 128.622 226.145 129.006 225.308 129.213Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M169.418 56.3366C168.432 56.581 167.513 56.5906 166.832 56.4309C166.122 56.2644 165.817 55.9593 165.753 55.6999C165.689 55.4404 165.816 55.0282 166.366 54.5494C166.893 54.0902 167.71 53.6692 168.696 53.4248C169.682 53.1804 170.601 53.1708 171.282 53.3305C171.991 53.497 172.296 53.8022 172.361 54.0616C172.425 54.321 172.298 54.7332 171.748 55.212C171.221 55.6712 170.404 56.0922 169.418 56.3366Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M169.418 129.337C168.432 129.581 167.513 129.591 166.832 129.431C166.122 129.264 165.817 128.959 165.753 128.7C165.689 128.44 165.816 128.028 166.366 127.549C166.893 127.09 167.71 126.669 168.696 126.425C169.682 126.18 170.601 126.171 171.282 126.331C171.991 126.497 172.296 126.802 172.361 127.062C172.425 127.321 172.298 127.733 171.748 128.212C171.221 128.671 170.404 129.092 169.418 129.337Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M206.778 56.2473C205.899 56.4652 205.077 56.4539 204.467 56.2837C203.84 56.1088 203.544 55.8057 203.473 55.5213C203.403 55.2369 203.523 54.8304 203.996 54.383C204.456 53.9474 205.177 53.5534 206.056 53.3355C206.935 53.1176 207.757 53.129 208.367 53.2992C208.994 53.4741 209.29 53.7771 209.361 54.0616C209.431 54.346 209.311 54.7524 208.838 55.1999C208.378 55.6354 207.657 56.0294 206.778 56.2473Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M206.778 129.247C205.899 129.465 205.077 129.454 204.467 129.284C203.84 129.109 203.544 128.806 203.473 128.521C203.403 128.237 203.523 127.83 203.996 127.383C204.456 126.947 205.177 126.553 206.056 126.336C206.935 126.118 207.757 126.129 208.367 126.299C208.994 126.474 209.29 126.777 209.361 127.062C209.431 127.346 209.311 127.752 208.838 128.2C208.378 128.635 207.657 129.029 206.778 129.247Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M150.768 56.2498C149.886 56.4684 149.062 56.4576 148.45 56.2876C147.821 56.113 147.524 55.8099 147.454 55.5262C147.383 55.2424 147.504 54.8359 147.979 54.3876C148.44 53.9513 149.164 53.5566 150.046 53.3379C150.928 53.1193 151.753 53.1301 152.365 53.3001C152.994 53.4747 153.29 53.7778 153.361 54.0615C153.431 54.3453 153.31 54.7518 152.836 55.2001C152.374 55.6364 151.65 56.0311 150.768 56.2498Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M150.768 129.25C149.886 129.468 149.062 129.458 148.45 129.288C147.821 129.113 147.524 128.81 147.454 128.526C147.383 128.242 147.504 127.836 147.979 127.388C148.44 126.951 149.164 126.557 150.046 126.338C150.928 126.119 151.753 126.13 152.365 126.3C152.994 126.475 153.29 126.778 153.361 127.062C153.431 127.345 153.31 127.752 152.836 128.2C152.374 128.636 151.65 129.031 150.768 129.25Z",
    fill: "#B5D4F5",
    stroke: "#6F9AC7"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 128.286,
    y: 148.5,
    width: 103,
    height: 131,
    stroke: "#6F9AC7"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 129.286,
    y: 149.5,
    width: 101,
    height: 129,
    fill: "#7CA8D6",
    stroke: "#B5D4F5"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M226.286 154.5L231.286 148.5M226.286 273.5L231.286 279.5M133.286 273.5L128.286 279.5M133.286 154.5L128.286 148.5",
    stroke: "#6F9AC7"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 133.286,
    y: 154.5,
    width: 93,
    height: 119,
    fill: "#6F9AC7",
    stroke: "#527DA9"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 142.286,
    y: 154.5,
    width: 75,
    height: 119,
    fill: "#6F9AC7",
    stroke: "#527DA9"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 141.786,
    y: 163,
    width: 76,
    height: 102,
    fill: "#527DA9"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 144.786,
    y: 166,
    width: 70,
    height: 96,
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M351.167 195.014C351.167 229.892 327.361 258.014 298.167 258.014C268.973 258.014 245.167 229.892 245.167 195.014C245.167 160.137 268.973 132.014 298.167 132.014C327.361 132.014 351.167 160.137 351.167 195.014Z",
    fill: "#527DA9",
    stroke: "#6F9AC7"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M337.424 195.014C337.424 222.789 319.743 245.09 298.167 245.09C276.592 245.09 258.911 222.789 258.911 195.014C258.911 167.24 276.592 144.939 298.167 144.939C319.743 144.939 337.424 167.24 337.424 195.014Z",
    fill: "#6F9AC7",
    stroke: "#527DA9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M348.961 194.834C348.961 228.613 326.161 255.834 298.217 255.834C270.274 255.834 247.474 228.613 247.474 194.834C247.474 161.055 270.274 133.834 298.217 133.834C326.161 133.834 348.961 161.055 348.961 194.834Z",
    stroke: "#6F9AC7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.167,
    cy: 195.014,
    rx: 34.992,
    ry: 45.6581,
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M297.667 248.514C298.167 247.514 294.167 247.514 294.667 248.514C295.167 249.514 295.167 251.513 295.167 252.513V252.514C295.167 253.514 294.167 255.014 294.167 256.014C294.167 257.014 298.167 257.014 298.167 256.014C298.167 255.014 297.167 253.514 297.167 252.514C297.167 251.514 297.167 249.514 297.667 248.514Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M297.667 256.014C297.667 255.514 296.667 253.514 296.667 252.514H295.667C295.667 253.514 294.667 255.514 294.667 256.014C294.667 256.514 297.667 256.722 297.667 256.014Z",
    fill: "#B5D4F5"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M301.367 248.271C301.8 247.24 297.809 247.501 298.373 248.466C298.937 249.431 299.067 251.426 299.132 252.424L299.132 252.425C299.198 253.423 298.298 254.985 298.363 255.983C298.428 256.981 302.419 256.72 302.354 255.722C302.289 254.724 301.193 253.293 301.128 252.295C301.063 251.297 300.933 249.301 301.367 248.271Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M301.855 255.755C301.823 255.256 300.695 253.325 300.629 252.327L299.632 252.392C299.697 253.39 298.829 255.451 298.862 255.95C298.894 256.449 301.901 256.46 301.855 255.755Z",
    fill: "#B5D4F5"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M304.908 247.606C305.223 246.533 301.286 247.244 301.956 248.139C302.625 249.034 302.981 251.001 303.158 251.985L303.159 251.986C303.336 252.97 302.619 254.624 302.796 255.608C302.974 256.592 306.91 255.882 306.733 254.898C306.555 253.914 305.304 252.615 305.127 251.631C304.949 250.647 304.594 248.679 304.908 247.606Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M306.241 254.986C306.152 254.494 304.813 252.704 304.635 251.72L303.651 251.897C303.828 252.882 303.2 255.027 303.288 255.519C303.377 256.012 306.366 255.682 306.241 254.986Z",
    fill: "#B5D4F5"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M308.379 246.478C308.61 245.384 304.74 246.395 305.476 247.237C306.212 248.077 306.718 250.011 306.971 250.979L306.971 250.98C307.224 251.948 306.636 253.652 306.889 254.619C307.142 255.587 311.012 254.575 310.759 253.608C310.506 252.64 309.159 251.442 308.906 250.475C308.653 249.507 308.148 247.572 308.379 246.478Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M310.275 253.734C310.148 253.251 308.675 251.568 308.422 250.601L307.455 250.854C307.708 251.821 307.246 254.009 307.372 254.493C307.499 254.977 310.454 254.418 310.275 253.734Z",
    fill: "#B5D4F5"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M311.985 244.927C312.115 243.817 308.354 245.178 309.164 245.949C309.974 246.718 310.655 248.598 310.995 249.539L310.996 249.54C311.336 250.48 310.907 252.231 311.247 253.171C311.587 254.111 315.349 252.75 315.008 251.809C314.668 250.869 313.217 249.799 312.876 248.859C312.536 247.919 311.855 246.038 311.985 244.927Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M314.538 251.979C314.368 251.509 312.747 249.969 312.406 249.029L311.466 249.369C311.806 250.31 311.547 252.531 311.717 253.001C311.887 253.471 314.779 252.644 314.538 251.979Z",
    fill: "#B5D4F5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M315.326 243.193C315.338 242.075 311.742 243.827 312.629 244.507C313.516 245.187 314.392 246.984 314.83 247.883L314.83 247.884C315.268 248.783 315.026 250.57 315.464 251.469C315.902 252.368 319.498 250.616 319.06 249.717C318.622 248.818 317.066 247.907 316.628 247.008C316.19 246.109 315.314 244.311 315.326 243.193Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M318.611 249.936C318.392 249.486 316.617 248.126 316.179 247.227L315.28 247.665C315.718 248.564 315.695 250.8 315.914 251.25C316.133 251.699 318.921 250.571 318.611 249.936Z",
    fill: "#B5D4F5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M318.392 241.181C318.319 240.065 314.866 242.084 315.803 242.695C316.739 243.306 317.748 245.031 318.253 245.895L318.253 245.896C318.758 246.759 318.652 248.558 319.157 249.422C319.662 250.285 323.115 248.266 322.61 247.403C322.105 246.539 320.485 245.749 319.98 244.886C319.475 244.023 318.466 242.296 318.392 241.181Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M322.178 247.655C321.926 247.223 320.053 246.002 319.548 245.138L318.685 245.643C319.19 246.506 319.336 248.738 319.589 249.169C319.841 249.601 322.535 248.265 322.178 247.655Z",
    fill: "#B5D4F5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M321.348 238.89C321.145 237.79 317.951 240.199 318.953 240.696C319.954 241.193 321.157 242.789 321.76 243.588L321.76 243.589C322.363 244.387 322.468 246.187 323.07 246.985C323.672 247.783 326.865 245.375 326.263 244.576C325.661 243.778 323.959 243.183 323.357 242.384C322.755 241.586 321.551 239.989 321.348 238.89Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M325.422 245.047C325.121 244.648 325.076 244.144 323.828 243.852L322.16 243.287C322.762 244.086 323.168 246.285 323.469 246.684C323.77 247.083 325.847 245.612 325.422 245.047Z",
    fill: "#B5D4F5"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M324.181 236.373C323.914 235.287 320.868 237.88 321.897 238.317C322.925 238.755 324.22 240.277 324.869 241.039L324.869 241.04C325.517 241.801 325.728 243.592 326.376 244.353C327.024 245.115 330.071 242.523 329.423 241.761C328.774 240.999 327.041 240.505 326.393 239.744C325.744 238.982 324.449 237.459 324.181 236.373Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M328.61 242.281C328.286 241.9 328.212 241.4 326.949 241.181L325.25 240.716C325.898 241.477 326.433 243.648 326.757 244.029C327.081 244.41 329.068 242.819 328.61 242.281Z",
    fill: "#B5D4F5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M326.683 233.732C326.318 232.675 323.519 235.532 324.583 235.875C325.647 236.217 327.075 237.617 327.789 238.317L327.79 238.317C328.504 239.017 328.876 240.781 329.59 241.481C330.304 242.181 333.104 239.324 332.389 238.624C331.675 237.924 329.904 237.589 329.189 236.889C328.475 236.189 327.047 234.789 326.683 233.732Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M331.627 239.215C331.27 238.865 331.151 238.374 329.873 238.27L328.14 237.96C328.854 238.66 329.583 240.774 329.94 241.124C330.297 241.474 332.132 239.71 331.627 239.215Z",
    fill: "#B5D4F5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M329.059 230.967C328.618 229.939 326.036 232.994 327.123 233.258C328.209 233.521 329.736 234.812 330.5 235.458L330.501 235.458C331.264 236.104 331.765 237.836 332.528 238.481C333.292 239.127 335.874 236.071 335.11 235.426C334.347 234.781 332.555 234.576 331.791 233.931C331.028 233.285 329.5 231.994 329.059 230.967Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M334.009 236.773C333.745 236.55 333.638 236.217 332.751 236.211L331.539 236.085C332.068 236.531 332.678 237.953 332.942 238.176C333.206 238.4 334.383 237.089 334.009 236.773Z",
    fill: "#B5D4F5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M330.946 228.1C330.413 227.117 328.12 230.395 329.226 230.559C330.332 230.722 331.97 231.867 332.79 232.441L332.791 232.441C333.611 233.014 334.267 234.693 335.086 235.266C335.906 235.839 338.198 232.561 337.379 231.988C336.559 231.415 334.757 231.375 333.937 230.802C333.117 230.229 331.479 229.083 330.946 228.1Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M336.405 233.431C336.122 233.232 335.985 232.91 335.101 232.985L333.882 232.97C334.45 233.367 335.187 234.727 335.471 234.925C335.754 235.123 336.806 233.711 336.405 233.431Z",
    fill: "#B5D4F5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M332.677 224.891C332.072 223.95 330.029 227.389 331.144 227.47C332.258 227.551 333.977 228.572 334.837 229.084L334.838 229.084C335.697 229.595 336.476 231.221 337.335 231.732C338.195 232.243 340.239 228.804 339.379 228.293C338.52 227.783 336.719 227.876 335.859 227.365C335 226.854 333.281 225.832 332.677 224.891Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M338.515 229.804C338.218 229.627 338.057 229.316 337.181 229.456L335.965 229.531C336.56 229.884 337.396 231.186 337.693 231.363C337.991 231.54 338.936 230.054 338.515 229.804Z",
    fill: "#B5D4F5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M334.34 221.545C333.678 220.644 331.854 224.203 332.972 224.215C334.089 224.226 335.868 225.138 336.758 225.594L336.759 225.595C337.649 226.051 338.528 227.625 339.417 228.081C340.307 228.537 342.132 224.978 341.242 224.522C340.352 224.065 338.561 224.271 337.671 223.815C336.782 223.359 335.002 222.446 334.34 221.545Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M340.474 226.083C340.167 225.925 339.987 225.625 339.122 225.819L337.912 225.97C338.528 226.286 339.444 227.533 339.752 227.691C340.06 227.849 340.91 226.306 340.474 226.083Z",
    fill: "#B5D4F5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M335.752 218.078C335.045 217.211 333.404 220.859 334.521 220.814C335.638 220.768 337.461 221.588 338.373 221.998L338.374 221.999C339.286 222.409 340.244 223.936 341.156 224.347C342.068 224.757 343.709 221.109 342.797 220.699C341.885 220.289 340.107 220.585 339.195 220.175C338.283 219.765 336.459 218.944 335.752 218.078Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M337.087 214.536C336.332 213.711 334.9 217.446 336.013 217.337C337.125 217.228 338.992 217.944 339.926 218.302L339.927 218.303C340.86 218.661 341.903 220.131 342.837 220.489C343.77 220.847 345.203 217.113 344.269 216.755C343.335 216.396 341.577 216.793 340.643 216.435C339.709 216.077 337.842 215.361 337.087 214.536Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M338.16 211.073C337.358 210.293 336.145 214.105 337.249 213.932C338.354 213.759 340.258 214.365 341.212 214.669L341.213 214.669C342.165 214.972 343.291 216.38 344.244 216.684C345.197 216.987 346.411 213.175 345.458 212.872C344.505 212.569 342.772 213.067 341.819 212.763C340.866 212.46 338.961 211.853 338.16 211.073Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M338.977 207.289C338.134 206.555 337.135 210.428 338.228 210.194C339.321 209.96 341.256 210.459 342.225 210.709L342.226 210.709C343.194 210.959 344.397 212.301 345.365 212.551C346.334 212.801 347.333 208.928 346.364 208.678C345.396 208.428 343.694 209.022 342.725 208.772C341.757 208.523 339.821 208.023 338.977 207.289Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M339.758 203.573C338.867 202.898 338.131 206.83 339.206 206.522C340.281 206.215 342.246 206.582 343.229 206.766L343.23 206.767C344.213 206.95 345.503 208.209 346.486 208.393C347.469 208.577 348.205 204.645 347.222 204.461C346.239 204.277 344.581 204.985 343.598 204.801C342.615 204.617 340.649 204.249 339.758 203.573Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M340.132 199.86C339.192 199.256 338.763 203.233 339.81 202.843C340.858 202.453 342.845 202.668 343.84 202.775L343.841 202.775C344.835 202.882 346.219 204.037 347.213 204.145C348.208 204.252 348.637 200.275 347.643 200.168C346.648 200.06 345.05 200.894 344.056 200.787C343.061 200.68 341.073 200.465 340.132 199.86Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M301.367 141.975C301.8 143.005 297.809 142.745 298.373 141.78C298.937 140.815 299.067 138.82 299.132 137.822L299.132 137.821C299.198 136.823 298.298 135.261 298.363 134.263C298.428 133.265 302.419 133.526 302.354 134.524C302.289 135.521 301.193 136.953 301.128 137.951C301.063 138.949 300.933 140.945 301.367 141.975Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M304.908 142.64C305.223 143.713 301.286 143.002 301.956 142.107C302.625 141.212 302.981 139.245 303.158 138.26L303.159 138.259C303.336 137.275 302.619 135.621 302.796 134.637C302.974 133.653 306.91 134.364 306.733 135.348C306.555 136.332 305.304 137.63 305.127 138.615C304.949 139.599 304.594 141.567 304.908 142.64Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M308.379 143.767C308.61 144.861 304.74 143.85 305.476 143.009C306.212 142.168 306.718 140.234 306.971 139.266L306.971 139.265C307.224 138.298 306.636 136.594 306.889 135.626C307.142 134.659 311.012 135.67 310.759 136.638C310.506 137.605 309.159 138.804 308.906 139.771C308.653 140.738 308.148 142.674 308.379 143.767Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M311.985 145.318C312.115 146.429 308.354 145.067 309.164 144.297C309.974 143.527 310.655 141.648 310.995 140.707L310.996 140.706C311.336 139.766 310.907 138.015 311.247 137.075C311.587 136.134 315.349 137.496 315.008 138.436C314.668 139.377 313.217 140.447 312.876 141.387C312.536 142.327 311.855 144.208 311.985 145.318Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M315.326 147.052C315.338 148.17 311.742 146.418 312.629 145.738C313.516 145.059 314.392 143.262 314.83 142.362L314.83 142.361C315.268 141.462 315.026 139.676 315.464 138.777C315.902 137.878 319.498 139.63 319.06 140.529C318.622 141.428 317.066 142.338 316.628 143.237C316.19 144.136 315.314 145.934 315.326 147.052Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M318.392 149.065C318.319 150.181 314.866 148.161 315.803 147.551C316.739 146.94 317.748 145.214 318.253 144.351L318.253 144.35C318.758 143.487 318.652 141.687 319.157 140.824C319.662 139.961 323.115 141.98 322.61 142.843C322.105 143.706 320.485 144.496 319.98 145.359C319.475 146.223 318.466 147.949 318.392 149.065Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M321.348 151.356C321.145 152.456 317.951 150.047 318.953 149.55C319.954 149.052 321.157 147.456 321.76 146.658L321.76 146.657C322.363 145.859 322.468 144.059 323.07 143.261C323.672 142.462 326.865 144.871 326.263 145.669C325.661 146.468 323.959 147.063 323.357 147.861C322.755 148.66 321.551 150.257 321.348 151.356Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M324.181 153.872C323.914 154.958 320.868 152.366 321.897 151.928C322.925 151.491 324.22 149.968 324.869 149.207L324.869 149.206C325.517 148.444 325.728 146.654 326.376 145.892C327.024 145.131 330.071 147.723 329.423 148.485C328.774 149.246 327.041 149.74 326.393 150.502C325.744 151.263 324.449 152.787 324.181 153.872Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M326.683 156.513C326.318 157.571 323.519 154.713 324.583 154.371C325.647 154.028 327.075 152.629 327.789 151.929L327.79 151.928C328.504 151.228 328.876 149.464 329.59 148.764C330.304 148.065 333.104 150.922 332.389 151.621C331.675 152.321 329.904 152.657 329.189 153.357C328.475 154.056 327.047 155.456 326.683 156.513Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M329.059 159.279C328.618 160.306 326.036 157.251 327.123 156.988C328.209 156.724 329.736 155.434 330.5 154.788L330.501 154.787C331.264 154.142 331.765 152.41 332.528 151.764C333.292 151.119 335.874 154.174 335.11 154.82C334.347 155.465 332.555 155.669 331.791 156.315C331.028 156.96 329.5 158.251 329.059 159.279Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M330.946 162.145C330.413 163.128 328.12 159.85 329.226 159.687C330.332 159.524 331.97 158.378 332.79 157.805L332.791 157.804C333.611 157.231 334.267 155.552 335.086 154.979C335.906 154.406 338.198 157.684 337.379 158.257C336.559 158.83 334.757 158.87 333.937 159.443C333.117 160.016 331.479 161.163 330.946 162.145Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M332.677 165.354C332.072 166.295 330.029 162.857 331.144 162.776C332.258 162.694 333.977 161.673 334.837 161.162L334.838 161.161C335.697 160.651 336.476 159.025 337.335 158.514C338.195 158.003 340.239 161.441 339.379 161.952C338.52 162.463 336.719 162.37 335.859 162.881C335 163.391 333.281 164.414 332.677 165.354Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M334.34 168.701C333.678 169.602 331.854 166.042 332.972 166.031C334.089 166.02 335.868 165.108 336.758 164.651L336.759 164.651C337.649 164.195 338.528 162.621 339.417 162.164C340.307 161.708 342.132 165.268 341.242 165.724C340.352 166.18 338.561 165.974 337.671 166.431C336.782 166.887 335.002 167.799 334.34 168.701Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M335.752 172.168C335.045 173.034 333.404 169.386 334.521 169.432C335.638 169.478 337.461 168.657 338.373 168.247L338.374 168.247C339.286 167.836 340.244 166.309 341.156 165.899C342.068 165.489 343.709 169.136 342.797 169.547C341.885 169.957 340.107 169.66 339.195 170.07C338.283 170.481 336.459 171.302 335.752 172.168Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M337.087 175.71C336.332 176.535 334.9 172.8 336.013 172.909C337.125 173.017 338.992 172.302 339.926 171.943L339.927 171.943C340.86 171.585 341.903 170.114 342.837 169.756C343.77 169.398 345.203 173.133 344.269 173.491C343.335 173.849 341.577 173.452 340.643 173.81C339.709 174.168 337.842 174.885 337.087 175.71Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M338.16 179.172C337.358 179.952 336.145 176.141 337.249 176.314C338.354 176.487 340.258 175.88 341.212 175.577L341.213 175.577C342.165 175.273 343.291 173.865 344.244 173.562C345.197 173.259 346.411 177.07 345.458 177.373C344.505 177.677 342.772 177.179 341.819 177.482C340.866 177.785 338.961 178.393 338.16 179.172Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M338.977 182.957C338.134 183.691 337.135 179.817 338.228 180.052C339.321 180.286 341.256 179.787 342.225 179.537L342.226 179.537C343.194 179.287 344.397 177.944 345.365 177.694C346.334 177.445 347.333 181.318 346.364 181.568C345.396 181.817 343.694 181.223 342.725 181.473C341.757 181.723 339.821 182.223 338.977 182.957Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M339.758 186.672C338.867 187.348 338.131 183.416 339.206 183.723C340.281 184.031 342.246 183.663 343.229 183.479L343.23 183.479C344.213 183.295 345.503 182.036 346.486 181.852C347.469 181.669 348.205 185.6 347.222 185.784C346.239 185.968 344.581 185.261 343.598 185.445C342.615 185.629 340.649 185.997 339.758 186.672Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M340.132 190.385C339.192 190.99 338.763 187.013 339.81 187.403C340.858 187.792 342.845 187.578 343.84 187.471L343.841 187.471C344.835 187.363 346.219 186.208 347.213 186.101C348.208 185.994 348.637 189.971 347.643 190.078C346.648 190.185 345.05 189.352 344.056 189.459C343.061 189.566 341.073 189.781 340.132 190.385Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M340.132 196.303C339.139 195.789 339.082 199.788 340.089 199.303C341.096 198.817 343.095 198.846 344.095 198.86L344.096 198.86C345.096 198.874 346.581 199.895 347.581 199.91C348.581 199.924 348.638 195.924 347.638 195.91C346.639 195.896 345.124 196.874 344.124 196.86C343.125 196.846 341.125 196.817 340.132 196.303Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M340.132 191.771C339.139 191.257 339.082 195.257 340.089 194.771C341.096 194.286 343.095 194.314 344.095 194.329L344.096 194.329C345.096 194.343 346.581 195.364 347.581 195.378C348.581 195.393 348.638 191.393 347.638 191.379C346.639 191.365 345.124 192.343 344.124 192.329C343.125 192.315 341.125 192.286 340.132 191.771Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M294.667 141.764C294.167 142.764 298.167 142.764 297.667 141.764C297.167 140.765 297.167 138.766 297.167 137.765L297.167 137.764C297.167 136.764 298.167 135.264 298.167 134.264C298.167 133.264 294.167 133.264 294.167 134.264C294.167 135.264 295.167 136.764 295.168 137.764C295.168 138.764 295.167 140.764 294.667 141.764Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M291.312 247.425C290.998 246.352 294.934 247.063 294.264 247.958C293.595 248.853 293.24 250.82 293.062 251.805L293.062 251.806C292.884 252.79 293.601 254.444 293.424 255.428C293.246 256.412 289.31 255.701 289.487 254.717C289.665 253.733 290.916 252.435 291.094 251.45C291.271 250.466 291.626 248.498 291.312 247.425Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M289.979 254.806C290.068 254.314 291.408 252.523 291.585 251.539L292.569 251.717C292.392 252.701 293.021 254.847 292.932 255.339C292.843 255.831 289.854 255.502 289.979 254.806Z",
    fill: "#B5D4F5"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M287.842 246.297C287.611 245.203 291.481 246.215 290.744 247.056C290.008 247.897 289.502 249.831 289.249 250.799L289.249 250.8C288.996 251.767 289.584 253.471 289.332 254.439C289.079 255.406 285.209 254.395 285.462 253.427C285.714 252.46 287.061 251.261 287.314 250.294C287.567 249.326 288.073 247.391 287.842 246.297Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M285.945 253.554C286.072 253.07 287.545 251.388 287.798 250.42L288.765 250.673C288.512 251.641 288.974 253.829 288.848 254.312C288.721 254.796 285.766 254.238 285.945 253.554Z",
    fill: "#B5D4F5"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M284.235 244.747C284.105 243.636 287.867 244.998 287.056 245.768C286.246 246.538 285.565 248.417 285.225 249.358L285.224 249.359C284.884 250.299 285.314 252.05 284.973 252.99C284.633 253.931 280.872 252.569 281.212 251.629C281.552 250.688 283.003 249.618 283.344 248.678C283.685 247.738 284.365 245.857 284.235 244.747Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M281.682 251.799C281.852 251.329 283.473 249.788 283.814 248.848L284.754 249.189C284.414 250.129 284.673 252.35 284.503 252.82C284.333 253.29 281.441 252.464 281.682 251.799Z",
    fill: "#B5D4F5"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M280.894 243.013C280.883 241.895 284.479 243.647 283.591 244.327C282.704 245.006 281.828 246.803 281.39 247.703L281.39 247.704C280.952 248.603 281.194 250.389 280.756 251.288C280.318 252.187 276.722 250.435 277.16 249.536C277.598 248.637 279.154 247.727 279.592 246.828C280.03 245.929 280.906 244.131 280.894 243.013Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M277.609 249.755C277.828 249.305 279.603 247.945 280.041 247.047L280.94 247.485C280.502 248.383 280.525 250.619 280.306 251.069C280.087 251.518 277.3 250.391 277.609 249.755Z",
    fill: "#B5D4F5"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M277.828 241C277.901 239.884 281.354 241.904 280.418 242.514C279.481 243.125 278.472 244.851 277.967 245.714L277.967 245.715C277.462 246.578 277.568 248.378 277.063 249.241C276.558 250.104 273.105 248.085 273.61 247.222C274.115 246.359 275.736 245.569 276.241 244.706C276.745 243.842 277.755 242.116 277.828 241Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M274.042 247.474C274.294 247.043 276.167 245.821 276.672 244.958L277.535 245.463C277.03 246.326 276.884 248.557 276.632 248.989C276.379 249.42 273.685 248.085 274.042 247.474Z",
    fill: "#B5D4F5"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M274.872 238.709C275.075 237.609 278.269 240.018 277.267 240.515C276.266 241.013 275.063 242.608 274.46 243.407L274.46 243.408C273.858 244.206 273.753 246.006 273.15 246.804C272.548 247.603 269.355 245.194 269.957 244.396C270.559 243.597 272.261 243.002 272.863 242.204C273.465 241.405 274.669 239.808 274.872 238.709Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M270.799 244.867C271.1 244.468 271.144 243.964 272.392 243.672L274.06 243.107C273.458 243.905 273.052 246.104 272.751 246.503C272.45 246.902 270.373 245.431 270.799 244.867Z",
    fill: "#B5D4F5"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M272.039 236.193C272.306 235.107 275.353 237.699 274.324 238.137C273.295 238.574 272 240.097 271.351 240.858L271.351 240.859C270.703 241.621 270.492 243.411 269.844 244.173C269.196 244.934 266.15 242.342 266.798 241.58C267.446 240.819 269.18 240.325 269.828 239.563C270.476 238.802 271.772 237.278 272.039 236.193Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M267.61 242.1C267.934 241.719 268.008 241.219 269.271 241.001L270.97 240.535C270.322 241.297 269.787 243.468 269.463 243.849C269.139 244.229 267.152 242.639 267.61 242.1Z",
    fill: "#B5D4F5"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M269.538 233.551C269.902 232.494 272.701 235.351 271.637 235.694C270.573 236.037 269.146 237.436 268.431 238.136L268.43 238.137C267.716 238.837 267.345 240.601 266.63 241.301C265.916 242 263.117 239.143 263.831 238.443C264.545 237.744 266.316 237.408 267.031 236.708C267.745 236.009 269.173 234.608 269.538 233.551Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M264.593 239.035C264.95 238.685 265.069 238.193 266.347 238.09L268.08 237.78C267.366 238.479 266.638 240.593 266.28 240.943C265.923 241.293 264.088 239.53 264.593 239.035Z",
    fill: "#B5D4F5"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M267.161 230.786C267.602 229.759 270.184 232.814 269.097 233.077C268.011 233.341 266.484 234.631 265.72 235.277L265.72 235.278C264.956 235.923 264.456 237.655 263.692 238.3C262.928 238.946 260.346 235.891 261.11 235.245C261.874 234.6 263.665 234.396 264.429 233.75C265.193 233.105 266.72 231.813 267.161 230.786Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M262.211 236.593C262.475 236.369 262.582 236.036 263.469 236.03L264.681 235.904C264.153 236.351 263.542 237.772 263.278 237.996C263.014 238.219 261.837 236.909 262.211 236.593Z",
    fill: "#B5D4F5"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M265.275 227.92C265.808 226.937 268.1 230.215 266.994 230.378C265.888 230.541 264.25 231.687 263.43 232.26L263.429 232.261C262.61 232.834 261.953 234.513 261.134 235.086C260.314 235.659 258.022 232.381 258.842 231.808C259.661 231.235 261.464 231.195 262.283 230.622C263.103 230.049 264.742 228.902 265.275 227.92Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M259.815 233.25C260.098 233.052 260.235 232.73 261.119 232.804L262.338 232.79C261.771 233.186 261.033 234.546 260.75 234.744C260.466 234.943 259.414 233.53 259.815 233.25Z",
    fill: "#B5D4F5"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M263.544 224.711C264.148 223.77 266.192 227.208 265.076 227.289C263.962 227.37 262.243 228.392 261.384 228.903L261.383 228.903C260.523 229.414 259.745 231.04 258.885 231.551C258.025 232.062 255.981 228.624 256.841 228.113C257.701 227.602 259.501 227.695 260.361 227.184C261.221 226.674 262.94 225.651 263.544 224.711Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M257.705 229.623C258.003 229.446 258.163 229.135 259.039 229.275L260.255 229.35C259.66 229.704 258.824 231.006 258.527 231.183C258.229 231.359 257.285 229.873 257.705 229.623Z",
    fill: "#B5D4F5"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M261.88 221.364C262.542 220.463 264.367 224.023 263.249 224.034C262.131 224.045 260.352 224.957 259.462 225.414L259.461 225.414C258.571 225.87 257.693 227.444 256.803 227.901C255.913 228.357 254.088 224.797 254.978 224.341C255.868 223.885 257.659 224.091 258.549 223.634C259.439 223.178 261.218 222.266 261.88 221.364Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M255.746 225.902C256.054 225.744 256.233 225.444 257.099 225.638L258.308 225.79C257.692 226.105 256.776 227.352 256.468 227.51C256.161 227.668 255.31 226.125 255.746 225.902Z",
    fill: "#B5D4F5"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M260.468 217.897C261.175 217.031 262.816 220.679 261.699 220.633C260.582 220.587 258.759 221.407 257.847 221.818L257.846 221.818C256.934 222.229 255.976 223.756 255.064 224.166C254.152 224.576 252.511 220.929 253.423 220.518C254.335 220.108 256.113 220.405 257.025 219.994C257.937 219.584 259.761 218.763 260.468 217.897Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M259.133 214.355C259.888 213.53 261.32 217.265 260.207 217.156C259.095 217.048 257.228 217.763 256.294 218.122L256.293 218.122C255.36 218.48 254.317 219.951 253.384 220.309C252.45 220.667 251.018 216.932 251.951 216.574C252.885 216.216 254.644 216.613 255.577 216.255C256.511 215.897 258.378 215.18 259.133 214.355Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M258.061 210.892C258.862 210.113 260.075 213.924 258.971 213.751C257.867 213.578 255.962 214.185 255.009 214.488L255.008 214.488C254.055 214.792 252.929 216.2 251.976 216.503C251.023 216.806 249.81 212.995 250.762 212.691C251.715 212.388 253.448 212.886 254.401 212.583C255.354 212.279 257.259 211.672 258.061 210.892Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M257.243 207.108C258.086 206.374 259.085 210.248 257.992 210.013C256.899 209.779 254.964 210.278 253.995 210.528L253.994 210.528C253.026 210.778 251.823 212.121 250.855 212.371C249.887 212.62 248.888 208.747 249.856 208.497C250.824 208.248 252.526 208.841 253.495 208.592C254.463 208.342 256.4 207.842 257.243 207.108Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M256.462 203.393C257.353 202.717 258.089 206.649 257.014 206.341C255.94 206.034 253.975 206.402 252.991 206.586L252.99 206.586C252.007 206.77 250.717 208.029 249.734 208.212C248.751 208.396 248.015 204.465 248.998 204.281C249.981 204.097 251.64 204.804 252.623 204.62C253.606 204.436 255.571 204.068 256.462 203.393Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M256.088 199.68C257.028 199.075 257.458 203.052 256.41 202.662C255.362 202.273 253.375 202.487 252.38 202.594L252.379 202.594C251.385 202.702 250.001 203.857 249.007 203.964C248.013 204.071 247.583 200.094 248.578 199.987C249.572 199.88 251.17 200.713 252.165 200.606C253.159 200.499 255.147 200.284 256.088 199.68Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M291.312 142.459C290.998 143.532 294.934 142.821 294.264 141.926C293.595 141.031 293.24 139.064 293.062 138.08L293.062 138.079C292.884 137.095 293.601 135.441 293.424 134.457C293.246 133.473 289.31 134.183 289.487 135.167C289.665 136.151 290.916 137.45 291.094 138.434C291.271 139.418 291.626 141.386 291.312 142.459Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M287.842 143.587C287.611 144.681 291.481 143.669 290.744 142.828C290.008 141.988 289.502 140.054 289.249 139.086L289.249 139.085C288.996 138.117 289.584 136.413 289.332 135.446C289.079 134.478 285.209 135.489 285.462 136.457C285.714 137.425 287.061 138.623 287.314 139.59C287.567 140.558 288.073 142.493 287.842 143.587Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M284.235 145.138C284.105 146.248 287.867 144.886 287.056 144.116C286.246 143.347 285.565 141.467 285.225 140.526L285.224 140.525C284.884 139.585 285.314 137.834 284.973 136.894C284.633 135.954 280.872 137.315 281.212 138.256C281.552 139.196 283.003 140.266 283.344 141.206C283.685 142.146 284.365 144.027 284.235 145.138Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M280.894 146.872C280.883 147.99 284.479 146.238 283.591 145.558C282.704 144.878 281.828 143.081 281.39 142.182L281.39 142.181C280.952 141.282 281.194 139.495 280.756 138.596C280.318 137.697 276.722 139.449 277.16 140.348C277.598 141.247 279.154 142.158 279.592 143.057C280.03 143.956 280.906 145.754 280.894 146.872Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M277.828 148.884C277.901 150 281.354 147.981 280.418 147.37C279.481 146.759 278.472 145.034 277.967 144.17L277.967 144.169C277.462 143.306 277.568 141.506 277.063 140.643C276.558 139.78 273.105 141.799 273.61 142.662C274.115 143.526 275.736 144.316 276.241 145.179C276.745 146.042 277.755 147.769 277.828 148.884Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M274.872 151.175C275.075 152.275 278.269 149.866 277.267 149.369C276.266 148.872 275.063 147.276 274.46 146.477L274.46 146.476C273.858 145.678 273.753 143.878 273.15 143.08C272.548 142.282 269.355 144.69 269.957 145.489C270.559 146.287 272.261 146.882 272.863 147.681C273.465 148.479 274.669 150.076 274.872 151.175Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M272.039 153.692C272.306 154.777 275.353 152.185 274.324 151.748C273.295 151.31 272 149.788 271.351 149.026L271.351 149.025C270.703 148.264 270.492 146.473 269.844 145.712C269.196 144.95 266.15 147.542 266.798 148.304C267.446 149.066 269.18 149.56 269.828 150.321C270.476 151.083 271.772 152.606 272.039 153.692Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M269.538 156.333C269.902 157.39 272.701 154.533 271.637 154.19C270.573 153.847 269.146 152.448 268.431 151.748L268.43 151.748C267.716 151.048 267.345 149.284 266.63 148.584C265.916 147.884 263.117 150.741 263.831 151.441C264.545 152.141 266.316 152.476 267.031 153.176C267.745 153.876 269.173 155.276 269.538 156.333Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M267.161 159.098C267.602 160.126 270.184 157.071 269.097 156.807C268.011 156.543 266.484 155.253 265.72 154.607L265.72 154.607C264.956 153.961 264.456 152.229 263.692 151.584C262.928 150.938 260.346 153.993 261.11 154.639C261.874 155.284 263.665 155.489 264.429 156.134C265.193 156.78 266.72 158.071 267.161 159.098Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M265.275 161.965C265.808 162.948 268.1 159.669 266.994 159.506C265.888 159.343 264.25 158.197 263.43 157.624L263.429 157.624C262.61 157.051 261.953 155.372 261.134 154.799C260.314 154.226 258.022 157.504 258.842 158.077C259.661 158.65 261.464 158.69 262.283 159.263C263.103 159.836 264.742 160.982 265.275 161.965Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M263.544 165.174C264.148 166.115 266.192 162.676 265.076 162.595C263.962 162.514 262.243 161.493 261.384 160.981L261.383 160.981C260.523 160.47 259.745 158.844 258.885 158.333C258.025 157.822 255.981 161.261 256.841 161.771C257.701 162.282 259.501 162.189 260.361 162.7C261.221 163.211 262.94 164.233 263.544 165.174Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M261.88 168.52C262.542 169.421 264.367 165.862 263.249 165.85C262.131 165.839 260.352 164.927 259.462 164.471L259.461 164.47C258.571 164.014 257.693 162.44 256.803 161.984C255.913 161.528 254.088 165.087 254.978 165.543C255.868 165.999 257.659 165.794 258.549 166.25C259.439 166.706 261.218 167.619 261.88 168.52Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M260.468 171.987C261.175 172.854 262.816 169.206 261.699 169.251C260.582 169.297 258.759 168.477 257.847 168.066L257.846 168.066C256.934 167.656 255.976 166.129 255.064 165.718C254.152 165.308 252.511 168.956 253.423 169.366C254.335 169.776 256.113 169.48 257.025 169.89C257.937 170.3 259.761 171.121 260.468 171.987Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M259.133 175.529C259.888 176.354 261.32 172.619 260.207 172.728C259.095 172.837 257.228 172.121 256.294 171.763L256.293 171.762C255.36 171.404 254.317 169.934 253.384 169.576C252.45 169.218 251.018 172.952 251.951 173.31C252.885 173.668 254.644 173.272 255.577 173.63C256.511 173.988 258.378 174.704 259.133 175.529Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M258.061 178.992C258.862 179.772 260.075 175.96 258.971 176.133C257.867 176.306 255.962 175.7 255.009 175.396L255.008 175.396C254.055 175.093 252.929 173.685 251.976 173.381C251.023 173.078 249.81 176.889 250.762 177.193C251.715 177.496 253.448 176.998 254.401 177.302C255.354 177.605 257.259 178.212 258.061 178.992Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M257.243 182.776C258.086 183.51 259.085 179.637 257.992 179.871C256.899 180.105 254.964 179.606 253.995 179.356L253.994 179.356C253.026 179.106 251.823 177.763 250.855 177.514C249.887 177.264 248.888 181.137 249.856 181.387C250.824 181.637 252.526 181.043 253.495 181.293C254.463 181.542 256.4 182.042 257.243 182.776Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M256.462 186.492C257.353 187.167 258.089 183.235 257.014 183.543C255.94 183.85 253.975 183.483 252.991 183.299L252.99 183.298C252.007 183.114 250.717 181.856 249.734 181.672C248.751 181.488 248.015 185.42 248.998 185.604C249.981 185.788 251.64 185.08 252.623 185.264C253.606 185.448 255.571 185.816 256.462 186.492Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M256.088 190.205C257.028 190.809 257.458 186.832 256.41 187.222C255.362 187.612 253.375 187.397 252.38 187.29L252.379 187.29C251.385 187.183 250.001 186.028 249.007 185.92C248.013 185.813 247.583 189.79 248.578 189.897C249.572 190.005 251.17 189.171 252.165 189.278C253.159 189.385 255.147 189.6 256.088 190.205Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M256.088 196.122C257.081 195.608 257.138 199.608 256.131 199.122C255.124 198.636 253.126 198.665 252.125 198.679L252.124 198.679C251.124 198.694 249.639 199.715 248.639 199.729C247.639 199.743 247.582 195.744 248.582 195.73C249.582 195.715 251.096 196.694 252.096 196.68C253.096 196.665 255.095 196.637 256.088 196.122Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M256.088 191.591C257.081 191.077 257.138 195.076 256.131 194.591C255.124 194.105 253.126 194.134 252.125 194.148L252.124 194.148C251.124 194.162 249.639 195.184 248.639 195.198C247.639 195.212 247.582 191.213 248.582 191.198C249.582 191.184 251.096 192.163 252.096 192.148C253.096 192.134 255.095 192.105 256.088 191.591Z",
    fill: "#7CA8D6",
    stroke: "#6F9AC7"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0019 347.819C96.612 347.43 95.7649 348.059 95.3902 348.422C95.5001 348.945 95.7461 350.078 95.8504 350.423C95.9808 350.855 95.641 350.978 95.397 351.18C95.153 351.382 94.8657 351.143 94.3344 351.106C93.0106 351.058 92.0777 352.306 92.748 352.863C92.6004 352.255 93.6543 352.24 93.9502 352.567C94.2461 352.894 95.0825 352.456 95.2567 352.439C95.3961 352.425 96.0232 352.482 96.3193 352.513C96.5602 352.578 97.0804 352.741 97.2336 352.868C97.4251 353.027 97.9477 352.976 98.1219 352.959C98.2613 352.945 98.6849 353.319 98.8793 353.507C98.9868 353.408 99.2123 353.136 99.2543 352.847C99.3068 352.486 99.4026 352.566 99.481 352.469C99.5595 352.373 100.369 352.56 100.648 352.711C100.871 352.831 102.239 352.495 102.895 352.312C103.055 352.148 103.389 351.783 103.445 351.635C103.514 351.451 104.02 351.223 104.507 351.709C104.473 350.467 103.428 350.569 102.757 350.902C102.086 351.235 100.78 351.363 99.5082 350.954C98.2368 350.545 97.4893 348.305 97.0019 347.819Z",
    fill: "white",
    stroke: "#6F9AC7"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M100.686 352.873C100.842 352.66 101.231 350.557 101.356 349.622L103.034 349.588C103.232 350.171 103.752 351.468 104.256 351.995C104.886 352.653 105.351 352.669 105.723 352.682C106.095 352.694 107.774 352.661 108.422 352.774C109.07 352.887 109.324 353.623 108.931 354.247C108.67 353.692 107.553 353.654 107.166 354.095C107.345 354.283 107.504 355.108 107.128 355.186C107.234 354.825 106.406 354.524 106.126 354.515C105.847 354.505 105.928 354.872 105.919 355.144C105.909 355.417 104.7 355.376 104.138 355.447C103.577 355.519 102.479 354.936 102.113 354.741C101.719 355.365 99.6654 355.476 99.3924 355.285C99.1195 355.094 98.4774 354.799 98.1765 355.426C97.9066 355.144 98.13 354.06 98.7907 353.809C99.4514 353.559 99.7181 353.932 100.187 353.857C100.655 353.782 100.491 353.14 100.686 352.873Z",
    fill: "white",
    stroke: "#6F9AC7"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0825 314.082C97.0825 315.411 96.8904 316.434 95.2945 317.651C93.6986 318.868 89.3023 320.463 86.9301 322.419C84.5578 324.375 80.719 326.635 73.3865 337.761C72.3945 339.022 69.9791 342.151 72.0494 341.76C70.6261 342.629 65.1052 348.366 68.9439 346.367C67.0892 347.714 66.2266 349.149 67.1755 349.235C67.003 350.061 67.8225 350.192 68.3832 350.018C68.9439 350.496 71.7907 348.279 72.3082 348.54C72.0494 349.757 80.072 347.367 82.6168 344.976C84.3421 346.923 90.9458 346.633 93.0449 347.241L94.1533 346.873L94.6406 347.85L95.3125 349.845C95.3125 349.845 95.2686 348.081 95.9844 348.081C96.7002 348.081 98.1681 348.837 98.1681 348.837C97.4416 346.881 97.7493 345.641 98.4344 345.352V346.004L100.793 348.648L101.234 351.168C101.234 351.168 102.094 350.433 102.619 350.391C103.144 350.349 104.488 350.874 104.488 350.874C104.014 349.657 101.263 346.352 101.539 344.961C101.884 343.222 107.145 339.046 106.929 338.263C108.396 337.481 111.861 332.198 111.947 328.113C112.033 324.027 111.861 322.636 109.488 320.507C109.143 318.377 108.337 315.428 107.776 314.602L106.699 312.177C106.263 311.31 105.644 310.167 105.929 308.721C106.303 308.473 106.489 307.148 106.699 306.879C107.514 306.721 108.306 305.567 109.074 305.158C109.372 305.461 110.341 306.117 110.298 306.512C110.289 306.547 110.28 306.581 110.271 306.613C110.285 306.582 110.294 306.548 110.298 306.512C110.548 305.516 110.836 304.535 109.074 303.805C107.249 303.049 106.245 303.412 105.927 303.573C104.934 303.167 102.889 303.243 100.714 304.007C97.9954 304.962 97.3604 305.122 96.5239 307.435C95.6874 309.748 96.5583 311.068 97.0825 314.082Z",
    fill: "#6F9AC7"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M108.652 303.554C110.56 304.022 110.78 306.087 110.651 307.061C110.564 306.722 110.056 306.026 109.687 305.752C108.991 306.265 107.405 307.359 106.626 307.635C106.458 307.929 105.649 308.833 105.683 309.807C105.716 310.781 106.119 311.38 106.785 312.438C107.647 314.153 108.396 318.719 108.761 319.513C107.766 319.284 107.007 317.927 106.284 317.924C106.584 318.876 106.078 319.928 105.683 320.968C104.96 320.797 103.351 320.256 102.691 319.459C102.845 320.813 101.523 322.017 100.954 322.987C100.419 322.51 99.2806 321.313 99.0052 320.342C98.44 322.263 91.7033 320.883 91.1992 321.423C91.2564 319.98 97.1652 317.579 96.4613 315.055C95.7574 312.53 95.4872 311.416 95.971 309.032C96.4547 306.648 97.2116 305.503 99.7482 304.167C101.778 303.098 104.067 303.304 105.104 303.554C105.394 303.35 106.744 303.085 108.652 303.554Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M110.651 307.061L111.395 307.159C111.348 307.515 111.055 307.788 110.696 307.81C110.338 307.831 110.014 307.595 109.925 307.247L110.651 307.061ZM108.652 303.554L108.473 304.282L108.652 303.554ZM105.104 303.554L105.535 304.167L105.258 304.362L104.929 304.283L105.104 303.554ZM99.7482 304.167L99.3987 303.504L99.7482 304.167ZM95.971 309.032L96.706 309.181L96.706 309.181L95.971 309.032ZM96.4613 315.055L97.1838 314.853L97.1838 314.853L96.4613 315.055ZM106.785 312.438L107.42 312.039L107.439 312.069L107.455 312.101L106.785 312.438ZM105.683 309.807L104.933 309.833L105.683 309.807ZM106.626 307.635L105.974 307.264L106.112 307.021L106.376 306.928L106.626 307.635ZM109.687 305.752L109.242 305.148L109.689 304.819L110.134 305.15L109.687 305.752ZM108.761 319.513L109.442 319.2L110.081 320.588L108.592 320.244L108.761 319.513ZM106.284 317.924L105.568 318.15L105.259 317.17L106.287 317.174L106.284 317.924ZM105.683 320.968L106.384 321.234L106.15 321.85L105.51 321.698L105.683 320.968ZM102.691 319.459L101.945 319.544L101.661 317.042L103.268 318.981L102.691 319.459ZM100.954 322.987L101.601 323.366L101.138 324.155L100.455 323.546L100.954 322.987ZM99.0052 320.342L98.2858 320.131L99.0185 317.641L99.7268 320.138L99.0052 320.342ZM91.1992 321.423L91.7473 321.935L90.3699 323.41L90.4498 321.393L91.1992 321.423ZM109.908 306.963C109.959 306.572 109.938 305.947 109.719 305.395C109.511 304.872 109.143 304.446 108.473 304.282L108.831 302.825C110.07 303.129 110.766 303.97 111.112 304.84C111.447 305.682 111.472 306.576 111.395 307.159L109.908 306.963ZM108.473 304.282C107.59 304.065 106.849 304.021 106.312 304.05C106.042 304.065 105.831 304.097 105.683 304.132C105.511 304.172 105.487 304.201 105.535 304.167L104.673 302.94C104.866 302.804 105.12 302.723 105.341 302.671C105.588 302.614 105.888 302.571 106.231 302.553C106.918 302.515 107.806 302.573 108.831 302.825L108.473 304.282ZM104.929 304.283C103.987 304.057 101.905 303.879 100.098 304.831L99.3987 303.504C101.65 302.318 104.146 302.552 105.279 302.824L104.929 304.283ZM100.098 304.831C98.8741 305.475 98.1603 306.033 97.6885 306.658C97.2192 307.28 96.9383 308.036 96.706 309.181L95.236 308.883C95.4874 307.643 95.8268 306.635 96.4911 305.755C97.1528 304.878 98.0857 304.195 99.3987 303.504L100.098 304.831ZM96.706 309.181C96.4753 310.318 96.4315 311.113 96.5166 311.911C96.6039 312.731 96.8289 313.58 97.1838 314.853L95.7389 315.256C95.3899 314.005 95.1278 313.035 95.025 312.07C94.9199 311.084 94.9829 310.13 95.236 308.883L96.706 309.181ZM106.15 312.838C105.509 311.818 104.975 311.045 104.933 309.833L106.432 309.781C106.458 310.516 106.729 310.941 107.42 312.039L106.15 312.838ZM104.933 309.833C104.909 309.141 105.182 308.525 105.427 308.094C105.554 307.872 105.685 307.679 105.788 307.531C105.848 307.446 105.879 307.403 105.92 307.344C105.937 307.319 105.95 307.3 105.96 307.285C105.971 307.269 105.974 307.263 105.974 307.264L107.278 308.006C107.213 308.12 107.093 308.283 107.017 308.391C106.923 308.526 106.823 308.675 106.73 308.837C106.537 309.176 106.422 309.499 106.432 309.781L104.933 309.833ZM106.376 306.928C106.673 306.823 107.197 306.527 107.783 306.151C108.348 305.789 108.905 305.397 109.242 305.148L110.132 306.356C109.773 306.62 109.189 307.032 108.592 307.414C108.016 307.783 107.357 308.172 106.876 308.342L106.376 306.928ZM110.134 305.15C110.404 305.351 110.675 305.661 110.879 305.938C111.071 306.2 111.296 306.557 111.378 306.875L109.925 307.247C109.927 307.255 109.915 307.214 109.862 307.119C109.814 307.033 109.748 306.932 109.67 306.827C109.506 306.603 109.338 306.428 109.239 306.354L110.134 305.15ZM107.455 312.101C107.934 313.055 108.355 314.721 108.689 316.15C108.864 316.897 109.013 317.569 109.149 318.14C109.291 318.735 109.389 319.084 109.442 319.2L108.08 319.827C107.95 319.545 107.818 319.026 107.69 318.488C107.556 317.926 107.395 317.2 107.229 316.492C106.882 315.011 106.498 313.537 106.115 312.775L107.455 312.101ZM108.592 320.244C107.867 320.077 107.28 319.52 106.916 319.188C106.702 318.994 106.547 318.854 106.407 318.757C106.262 318.655 106.233 318.674 106.28 318.674L106.287 317.174C106.696 317.176 107.033 317.365 107.265 317.526C107.502 317.691 107.734 317.905 107.925 318.079C108.37 318.483 108.66 318.72 108.93 318.783L108.592 320.244ZM106.999 317.698C107.211 318.37 107.124 319.033 106.968 319.609C106.817 320.169 106.564 320.759 106.384 321.234L104.981 320.702C105.196 320.138 105.394 319.682 105.52 319.217C105.641 318.769 105.657 318.43 105.568 318.15L106.999 317.698ZM105.51 321.698C105.109 321.603 104.481 321.411 103.858 321.134C103.257 320.866 102.558 320.474 102.113 319.938L103.268 318.981C103.484 319.242 103.919 319.519 104.469 319.763C104.997 319.999 105.534 320.162 105.855 320.238L105.51 321.698ZM103.436 319.375C103.543 320.319 103.13 321.145 102.723 321.774C102.516 322.095 102.285 322.401 102.089 322.665C101.883 322.941 101.719 323.165 101.601 323.366L100.307 322.607C100.474 322.323 100.689 322.033 100.886 321.769C101.092 321.492 101.289 321.23 101.464 320.96C101.821 320.406 101.992 319.954 101.945 319.544L103.436 319.375ZM100.455 323.546C100.16 323.283 99.7123 322.835 99.2979 322.32C98.8963 321.82 98.4638 321.182 98.2837 320.547L99.7268 320.138C99.822 320.473 100.097 320.919 100.467 321.38C100.824 321.824 101.214 322.213 101.453 322.427L100.455 323.546ZM99.7247 320.554C99.4523 321.48 98.5055 321.827 97.7704 321.98C96.9638 322.147 95.9817 322.169 95.0639 322.15C94.1676 322.132 93.183 322.068 92.5274 322.046C92.1753 322.034 91.9031 322.034 91.7128 322.048C91.6166 322.055 91.5678 322.065 91.552 322.069C91.5113 322.08 91.6289 322.062 91.7473 321.935L90.6511 320.911C90.8326 320.717 91.0619 320.646 91.1755 320.617C91.3141 320.581 91.4622 320.563 91.5996 320.552C91.8764 320.532 92.2175 320.535 92.5768 320.547C93.3437 320.572 94.1731 320.632 95.0947 320.651C95.9947 320.669 96.8343 320.642 97.4656 320.511C98.1683 320.365 98.2756 320.165 98.2858 320.131L99.7247 320.554ZM90.4498 321.393C90.4664 320.974 90.6836 320.624 90.8832 320.372C91.0942 320.106 91.3705 319.847 91.6594 319.602C92.2195 319.127 93.0005 318.566 93.6526 318.054C94.3452 317.511 94.9528 316.979 95.346 316.459C95.7407 315.938 95.8234 315.559 95.7389 315.256L97.1838 314.853C97.4512 315.813 97.0593 316.681 96.5423 317.364C96.0237 318.05 95.2825 318.682 94.5788 319.234C93.8345 319.819 93.1716 320.286 92.6297 320.746C92.3676 320.968 92.1783 321.153 92.058 321.305C91.9263 321.471 91.9463 321.511 91.9486 321.453L90.4498 321.393Z",
    fill: "#6F9AC7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 0.868785,
    transform: "matrix(-1 0 0 1 104.144 306.06)",
    fill: "#6F9AC7"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M142.965 19.4166C145.223 17.5686 149.453 16.7473 150.973 15.5975L164.672 12.825C165.561 15.6877 166.865 20.936 166.783 24.7961C166.701 28.6563 160.705 36.4177 159.309 37.1569C159.514 37.896 157.132 43.4809 156.804 45.1236C156.541 46.4377 157.379 49.0658 157.831 50.2157H153.026L154.627 45.1236L153.231 45.4931C153.327 44.2338 153.552 41.4441 153.683 40.36C152.889 40.6748 151.129 41.3866 150.439 41.7151C149.576 42.1258 149.207 45.1646 149.248 46.5609C149.281 47.6778 150.877 49.4628 151.671 50.2157L146.209 50.7495L146.907 44.754C144.909 44.1791 140.501 42.5693 138.858 40.7296C136.435 42.9882 128.797 45.2468 129.044 44.0969C128.551 43.8505 125.841 45.9449 125.307 45.4931C124.773 45.6574 123.993 45.5342 124.157 44.754C123.253 44.6718 124.075 43.3167 125.841 42.0437C122.186 43.9327 127.442 38.512 128.797 37.6907C126.826 38.0603 129.126 35.1036 130.07 33.9127C137.051 23.3999 140.706 21.2645 142.965 19.4166Z",
    fill: "#6F9AC7"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M147.997 9.46214C148.02 9.4876 148.042 9.5119 148.065 9.53499C148.039 9.51521 148.016 9.49069 147.997 9.46214C147.347 8.74177 146.452 7.0953 147.614 5.7013C148.816 4.25804 149.795 3.88158 150.133 3.87375C150.79 3.0935 152.647 1.45089 154.815 1.12236C157.525 0.711707 158.757 1.16343 160.482 2.72392C162.207 4.28441 162.549 4.83279 163.303 7.69285C164.118 10.7842 164.996 12.1012 164.996 16.8049L150.79 16.4809C151.119 14.4686 152.146 12.0869 152.679 11.3066C153.107 10.6824 153.159 8.82899 153.131 7.9803C152.707 7.93924 151.784 7.82426 151.489 7.69285C150.733 7.92281 148.891 7.9803 148.065 7.9803C147.947 8.36532 147.787 9.15207 147.997 9.46214Z",
    fill: "#7CA8D6"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M147.88 5.70297C146.677 7.14623 147.68 8.86012 148.331 9.53665C148.206 9.22676 148.203 8.40244 148.331 7.98197C149.158 7.98197 150.999 7.92448 151.755 7.69451C152.051 7.82592 152.973 7.9409 153.398 7.98197C153.425 8.83066 153.373 10.6841 152.946 11.3083C152.343 12.3876 151.179 14.751 151.348 15.5697C151.984 14.8286 152.842 14.3591 153.398 13.9464C153.706 14.8498 155.572 16.2285 156.466 16.8049C156.924 16.2638 157.856 14.9345 157.912 13.9464C158.562 15.0757 160.7 16.205 161.689 16.6284C161.83 15.9579 162.027 14.391 161.689 13.4876C163.213 14.6451 164.582 16.499 165.276 16.6284C165.276 14.5426 164.62 10.8428 163.783 7.98197C162.946 5.12116 162.473 4.28607 160.748 2.72558C159.024 1.1651 157.792 0.71337 155.081 1.12402C152.913 1.45255 151.057 3.09517 150.4 3.87541C150.061 3.88324 149.083 4.25971 147.88 5.70297Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M148.331 9.53665L147.971 9.88349C148.137 10.056 148.402 10.0865 148.603 9.95617C148.804 9.82588 148.884 9.57139 148.795 9.34935L148.331 9.53665ZM147.88 5.70297L148.264 6.02307H148.264L147.88 5.70297ZM150.4 3.87541L150.411 4.37528L150.637 4.37007L150.782 4.19748L150.4 3.87541ZM155.081 1.12402L155.006 0.629667L155.081 1.12402ZM160.748 2.72558L161.084 2.35482L160.748 2.72558ZM163.783 7.98197L164.263 7.84154V7.84154L163.783 7.98197ZM152.946 11.3083L152.533 11.0259L152.52 11.0446L152.509 11.0644L152.946 11.3083ZM153.398 7.98197L153.897 7.96585L153.883 7.52662L153.446 7.48429L153.398 7.98197ZM151.755 7.69451L151.958 7.2376L151.788 7.1619L151.609 7.21617L151.755 7.69451ZM148.331 7.98197V7.48197H147.961L147.853 7.836L148.331 7.98197ZM151.348 15.5697L150.859 15.671L151.065 16.6685L151.728 15.8951L151.348 15.5697ZM153.398 13.9464L153.871 13.7847L153.649 13.1363L153.099 13.5451L153.398 13.9464ZM156.466 16.8049L156.195 17.2251L156.563 17.4628L156.847 17.1282L156.466 16.8049ZM157.912 13.9464L158.346 13.6971L157.509 12.2417L157.413 13.9178L157.912 13.9464ZM161.689 16.6284L161.492 17.088L162.052 17.3283L162.178 16.7314L161.689 16.6284ZM161.689 13.4876L161.991 13.0894L160.613 12.0431L161.22 13.6631L161.689 13.4876ZM165.276 16.6284L165.185 17.12L165.776 17.2303V16.6284H165.276ZM148.691 9.18982C148.41 8.89827 148.049 8.37341 147.894 7.78061C147.744 7.20757 147.788 6.59461 148.264 6.02307L147.496 5.38286C146.769 6.25459 146.713 7.2202 146.926 8.03406C147.135 8.82815 147.6 9.4985 147.971 9.88349L148.691 9.18982ZM148.264 6.02307C148.837 5.33565 149.344 4.91759 149.73 4.67394C149.924 4.55197 150.085 4.47528 150.207 4.42983C150.268 4.40712 150.317 4.39302 150.353 4.38476C150.372 4.38066 150.386 4.37822 150.396 4.37682C150.407 4.37541 150.411 4.37528 150.411 4.37528L150.388 3.37555C150.089 3.38245 149.669 3.53054 149.197 3.82787C148.71 4.13522 148.126 4.62703 147.496 5.38286L148.264 6.02307ZM150.782 4.19748C151.08 3.84358 151.674 3.26898 152.453 2.7453C153.232 2.22131 154.169 1.76797 155.156 1.61838L155.006 0.629667C153.825 0.808599 152.75 1.34083 151.895 1.91534C151.04 2.49017 150.376 3.127 150.017 3.55334L150.782 4.19748ZM155.156 1.61838C156.478 1.4181 157.38 1.43817 158.142 1.66485C158.901 1.89073 159.574 2.3377 160.413 3.09635L161.084 2.35482C160.197 1.55298 159.393 0.993841 158.427 0.7064C157.464 0.41976 156.395 0.419293 155.006 0.629667L155.156 1.61838ZM160.413 3.09635C161.259 3.86221 161.765 4.42014 162.165 5.11567C162.572 5.82133 162.886 6.69526 163.303 8.1224L164.263 7.84154C163.844 6.40787 163.502 5.43385 163.032 4.61664C162.555 3.7893 161.962 3.14945 161.084 2.35482L160.413 3.09635ZM153.358 11.5906C153.518 11.3574 153.618 11.0522 153.687 10.7588C153.759 10.4548 153.807 10.1143 153.84 9.7777C153.905 9.10444 153.912 8.40684 153.897 7.96585L152.898 7.99809C152.911 8.40578 152.905 9.05924 152.844 9.68091C152.814 9.99182 152.771 10.2847 152.714 10.5303C152.654 10.7865 152.587 10.947 152.533 11.0259L153.358 11.5906ZM153.446 7.48429C153.241 7.46449 152.914 7.42662 152.605 7.37816C152.271 7.32567 152.035 7.27167 151.958 7.2376L151.552 8.15142C151.771 8.24876 152.144 8.31796 152.45 8.36608C152.783 8.41823 153.13 8.45838 153.349 8.47964L153.446 7.48429ZM151.609 7.21617C151.294 7.31213 150.699 7.38215 150.037 7.42555C149.391 7.46783 148.735 7.48197 148.331 7.48197V8.48197C148.753 8.48197 149.431 8.46736 150.102 8.42341C150.756 8.38056 151.46 8.30686 151.901 8.17285L151.609 7.21617ZM147.853 7.836C147.768 8.11422 147.736 8.48163 147.736 8.80144C147.736 9.10804 147.767 9.47421 147.867 9.72396L148.795 9.34935C148.77 9.2892 148.736 9.08827 148.736 8.80012C148.736 8.52518 148.766 8.27019 148.809 8.12794L147.853 7.836ZM152.509 11.0644C152.201 11.616 151.75 12.4942 151.396 13.3444C151.219 13.7688 151.062 14.1974 150.959 14.5809C150.862 14.9423 150.791 15.3427 150.859 15.671L151.838 15.4684C151.821 15.3874 151.832 15.1853 151.925 14.8396C152.011 14.516 152.151 14.1327 152.319 13.7291C152.655 12.923 153.087 12.0799 153.382 11.5521L152.509 11.0644ZM151.728 15.8951C152.009 15.5677 152.346 15.2919 152.695 15.0407C152.87 14.9152 153.042 14.799 153.212 14.6845C153.379 14.572 153.546 14.4588 153.696 14.3476L153.099 13.5451C152.971 13.6402 152.823 13.7405 152.653 13.8554C152.486 13.9681 152.3 14.093 152.111 14.2291C151.733 14.5012 151.323 14.8306 150.969 15.2443L151.728 15.8951ZM152.924 14.1081C153.033 14.4269 153.259 14.7414 153.505 15.0224C153.759 15.3118 154.068 15.6038 154.386 15.8776C155.024 16.4252 155.733 16.9274 156.195 17.2251L156.737 16.3847C156.304 16.106 155.634 15.6307 155.038 15.119C154.74 14.8631 154.469 14.605 154.258 14.3637C154.039 14.1141 153.916 13.9175 153.871 13.7847L152.924 14.1081ZM156.847 17.1282C157.094 16.8367 157.46 16.3437 157.775 15.7902C158.081 15.2503 158.377 14.588 158.412 13.9749L157.413 13.9178C157.392 14.2929 157.193 14.7892 156.905 15.2963C156.625 15.7897 156.296 16.232 156.084 16.4816L156.847 17.1282ZM157.479 14.1956C157.868 14.872 158.656 15.491 159.403 15.9724C160.169 16.4661 160.976 16.867 161.492 17.088L161.886 16.1689C161.413 15.9664 160.657 15.5909 159.944 15.1318C159.213 14.6603 158.606 14.15 158.346 13.6971L157.479 14.1956ZM162.178 16.7314C162.254 16.372 162.342 15.7851 162.368 15.1663C162.394 14.5613 162.363 13.8608 162.157 13.312L161.22 13.6631C161.353 14.0178 161.393 14.5525 161.369 15.1244C161.346 15.6826 161.265 16.2144 161.199 16.5254L162.178 16.7314ZM161.386 13.8858C162.114 14.4382 162.808 15.1602 163.439 15.7958C163.747 16.1064 164.046 16.4019 164.315 16.6285C164.563 16.8371 164.869 17.061 165.185 17.12L165.368 16.1369C165.369 16.1371 165.359 16.1354 165.337 16.1256C165.314 16.1159 165.284 16.1006 165.246 16.0773C165.169 16.0298 165.074 15.9595 164.959 15.8632C164.729 15.6697 164.46 15.405 164.149 15.0914C163.54 14.4782 162.788 13.6945 161.991 13.0894L161.386 13.8858ZM165.776 16.6284C165.776 14.477 165.107 10.7266 164.263 7.84154L163.303 8.1224C164.133 10.959 164.776 14.6082 164.776 16.6284H165.776Z",
    fill: "#7CA8D6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 0.836124,
    transform: "matrix(-1 0 0 1 153.652 4.19428)",
    fill: "#7CA8D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2931_42414",
    x: 0.332764,
    y: 50,
    width: 353.334,
    height: 237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2931_42414"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGallery);
export default __webpack_public_path__ + "static/media/no-gallery.d99a0b7e0ca44d1c58f691e1e2e2dadc.svg";
export { ForwardRef as ReactComponent };